<template>
  <v-container >
    <!-- Date Picker and Search Button -->
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top
          class="d-md-flex"
          outlined
          :useBtnList="[
            'btnSearch' //check
          ]"
          @btnSearch="search()"
        >
          <template v-slot:body>
            <v-layout column>
              <v-row no-gutters class="center pa-2 pb-0">                
                <i-label :label="'Plan Date : '" class="pl-2"/>
                <v-col cols="12" md="2">
                   <DxDateBox                        
                        :value="selectedDate"
                        height="30px"
                        display-format="yyyy-MM-dd"
                        :acceptCustomValue="false"
                        @value-changed="e => {selectedDate = e.value && getStrFormat(e.value)}"
                    />
                </v-col>
                <i-label :label="'Ship No : '" class="pl-2"/>
                <v-col cols="12" md="2">
                  <v-select
                    label="Ship No"
                    v-model="shipNo"
                    :items="listShipNo"
                    :item-value="`code`"
                    :item-text="`name`"
                    color="primary"
                    class="required mx-1 rounded-0"
                    :prepend-inner-icon="'$search'"
                    dense
                    outlined
                    clearable
                    @change = "search()"
                  ></v-select>
                </v-col>
                <i-label :label="'Block : '" class="pl-2"/>
                <v-col cols="12" md="2">
                 <v-text-field 
                    label="Block"
                    v-model="block"
                    dense
                    outlined
                    hide-details="auto"
                    :maxlength="4"
                    @input="limitInput"
                    @keyup="uppercase"
                  />                                                  
                </v-col>  
                <!-- <v-btn color="red" @click="$emit('switchToProgress')"> {{ data }} Quay lại Block Progress</v-btn>   -->
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
    </v-row>    
    <!-- Canvas Area -->
    <v-row no-gutters class="position-relative">
      <!-- Loading Indicator -->
      <v-container
        v-if="isLoading"
        class="loading-container"
        fill-height
      >
        <v-row justify="center" align="center" class="text-center">
          <v-col cols="12">
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
          </v-col>
          <v-col cols="12">
            <span class="loading-text">Loading...</span>
          </v-col>
        </v-row>
        <!-- <v-row justify="center" align="center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="40"
          >Loading...</v-progress-circular>
        </v-row> -->
      </v-container>
      <!-- Nội dung chính height="1900px"-->
      <v-col cols="12" class="pa-0">
        <v-sheet style="overflow-x: auto; overflow-y: auto" > 
          <canvas ref="logoCanvas" width="2250px" height="0px"></canvas> 
          <canvas ref="ani" width="2250px" height="2000px"
            @mousemove="handleMouseMove" 
            @mouseleave="hideTooltip"
            style="border:1px solid #000;"
          >BLOCK ARRANGEMENT</canvas>
          <canvas ref='textureCanvas' width="1px" height="2px"></canvas>
          <template>
          <div v-if="tooltip.show" 
            :style="tooltipStyle"
            class="tooltip-box"
            @mouseleave="hideTooltip">
            <!-- <strong>Detail Informaion</strong><br> -->
            Ship No. : {{ tooltip.data.shipno }}<br>
            Block    : {{ tooltip.data.block }}<br>
            P1 Block : {{ tooltip.data.peblk }}<br>
            Erection block : {{ tooltip.data.erectblk }}<br>
            Mid-PP Erection Date : {{ tooltip.data.edt }}<br>
            Est.PP Erection Date : {{ tooltip.data.actercdt }}<br>
            Weight : {{ tooltip.data.weight }}<br>
            Location : {{ tooltip.data.disloc }}<br>
            Work status : {{ tooltip.data.status }}
          </div>
          </template>
        </v-sheet>
      </v-col>  
    </v-row>   
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn, DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import iButton from '@/components/common/iButton'
import DxDateBox from 'devextreme-vue/date-box'
import themes from 'devextreme/ui/themes'
import ICardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs'
import moment from 'moment'
import {getDateFormat, getCurrentDate } from '@/utils/common.js'

import {CalRotPosX, CalRotPosY, CalRotPosXY, CalcInDock, CZ, CalcYposBay } from '@/utils/common.js'
import { onBlkQtyRetrieve, 
         getBlkCnt, 
         onFlatFormListRetrieve, 
         onBlkSuppBeamRetrieve, 
         onBlkShipEventRetrieve,
         getYardObj,
         getLastConfirm,
         getAddObjBlk,
         getDockArrangeList,
         listShipNo,
        } from '@/api/view/pp/20/v20a4020.js'

export default {
  mixins: [baseview, BaseDataGrid],

  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager,
    iButton
  },
  data() {
    return {
      top_y: 50, //50
      cur_x: null , 
      cur_y: null,
      canvas: null,
      context: null,  
      strStartDate: "",
      selectedDate: '',//new Date().toISOString().substr(0, 10),
      menu: false,
      PHI: 3.14159265,
      PHII: 314159,
      DATE_FORMAT: /^([0-9]{4}-[0-9]{2}-[0-9]{2})$/,

      zoom: 100,
			temp_zoom: 100,
			m_show_area: true,
			m_show_area_o: true,
			prt_margin: 0,	
      YardObj_Cnt: 0,
	    Blk_Cnt: 0,
	        
	    Start_X: null, Start_Y: null, Finish_X: null, Finish_Y: null, 
	       
	    Max_X: 2250, 
	    Max_Y: 2000, //1900

      YardObjList: [],
      DockObjList: [],
      BlkObjList: [],
      StockData: [[]], // Ban đầu là mảng rỗng
      shipNo:'',
      listShipNo:[],
      block: '',
      isLoading: false,
      objects:[],
      tooltip: { show: false, x: 0, y: 0, data: {} }
    };
  },
  computed: {
    tooltipStyle() {
      return {
        position: "absolute",
        top: this.tooltip.y + "px",
        left: this.tooltip.x + "px",
        background: "rgba(0,0,0,0.7)",
        color: "#fff",
        padding: "8px",
        borderRadius: "5px",
        fontSize: "12px",
        pointerEvents: "auto",// Cho phép nhận sự kiện
        cursor: "pointer"// Hiển thị bàn tay khi hover
        
      };
    }
  },
  props: {
    data: Object // Nhận dữ liệu từ `v20a4000.vue`
  },
  created() {
    this.setShipNo()
  },
  mounted() {
    let toDay = new Date;
        toDay.setDate(toDay.getDate());
    this.selectedDate = getDateFormat(toDay);

    if (this.data != null) {
      this.shipNo = this.data.strShipno
      this.block  = this.data.strBlock
    }
    
    // console.log('data', this.data);

    this.loadData(); 
  },
  beforeDestroy() {
   
  },
  methods: {
    limitInput() {
      if (this.block.length > 4) {
        this.block = this.block.slice(0, 4); // Cắt chỉ giữ lại 4 ký tự đầu tiên
      }
    },
    uppercase() {
      this.block = this.block.toUpperCase(); // Chuyển thành chữ in hoa
    },
    getStrFormat(date) {
      this.selectedDate = date
      return getDateFormat(date)
    },
    search() {
      this.loadData()
      // console.log("Searching for date: ", this.selectedDate);
    },
    
    validFormatStr(dateStr) {
      return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
    },
    //OK
    async loadData() {
      this.isLoading = true; // Bắt đầu loading
      try {
        await this.LoadYardObjList();
        await this.LoadBlkList();
        this.initCanvas();
      } catch (error) {
        console.error("Lỗi khi tải dữ liệu:", error);
      } finally {
        this.isLoading = false; // Kết thúc loading
      }
    },
    drawObjects() {
        this.ctx.clearRect(0, 0, 500, 300);
        this.objects.forEach(obj => {
        this.ctx.fillStyle = "blue";
        this.ctx.fillRect(obj.x, obj.y, obj.width, obj.height);
      });
    },
    initCanvas() {   
      // Lấy thẻ canvas và context
      this.canvas = this.$refs.ani;
      this.context = this.canvas.getContext("2d");
      // console.log("this.context: ", this.context);

      // Xóa canvas
      this.zoom = 100;//100
      this.canvas.height = 2000;//1900
			this.canvas.width  = 2250;
      // Xóa nền  
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

      // Gọi các hàm vẽ
      this.drawYard();
      this.drawLogo();
      this.drawExample(); //Hiển thị Block color remark
      this.DrawBlkSuppBeam();
      this.drawBorder();      
      this.drawShip() ;
      this.drawBlk() ;
      this.drawStockLoadStatus();
      this.DrawCapacity();//STOCK LOAD STATUS change to CAPACITY
      this.drawFlatFormList();
      this.drawShipEvent(); 
      
      // this.drawObjects();
    },
    drawLogo() {
      let logoTop = 0, logoLeft = 10;
      let logoWidth = 20;// độ dài cạnh tam giác đều
      let logoHeight = (logoWidth * 1.73) / 2;// Chiều cao tam giác đều

      let logoCanvas = this.$refs.logoCanvas;
      if (!logoCanvas) return;
      // Xóa nền      
      this.context.clearRect(0, 0, 300, 40);

      // Vẽ tam giác dưới cùng (xanh đậm)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 2 * logoHeight);//E
      this.context.lineTo(logoLeft + 10, logoTop + logoHeight);//F
      this.context.lineTo(logoLeft + 20, logoTop + 2 * logoHeight);//D
      this.context.closePath();
      this.context.fillStyle = "#0b833c"; // Xanh đậm
      this.context.fill();

      // Vẽ tam giác giữa (xanh vừa)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 0);//A
      this.context.lineTo(logoLeft + 20, logoTop + 2 * logoHeight);//D
      this.context.lineTo(logoLeft + 30, logoTop + logoHeight);//C
      this.context.closePath();
      this.context.fillStyle = "#12b041"; // Xanh vừa
      this.context.fill();

      // Vẽ tam giác trên cùng (xanh nhạt)
      this.context.beginPath();
      this.context.moveTo(logoLeft + 0, logoTop + 0);//A
      this.context.lineTo(logoLeft + 30, logoTop + logoHeight);//C
      this.context.lineTo(logoLeft + 20, logoTop + 0);//B
      this.context.closePath();
      this.context.fillStyle = "#38d52e"; // Xanh nhạt
      this.context.fill();

      // Vẽ chữ "HD"
      this.context.font = "bold 32px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("HD", logoLeft + 35, logoTop + 30);
      
      // Vẽ chữ "HYUNDAI VIETNAM"
      this.context.font = "bold 12px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("HYUNDAI VIETNAM", logoLeft + 85, logoTop + 18);

      // Vẽ chữ "SHIPBUILDING"
      this.context.font = "bold 12px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("SHIPBUILDING", logoLeft + 85, logoTop + 30);

      // Vẽ chữ "DAILY HVS BLOCK PILED LIST"
      this.context.font = "bold 32px Arial";//Arial
      this.context.fillStyle = "#003B79"; // Màu xanh đậm
      this.context.fillText("DAILY HVS BLOCK PILED LIST", logoLeft + 300, logoTop + 30);
    },
    async setShipNo() {
    // getShipNo
      const ship = async () => {
        await listShipNo().then(result => {
          result.list.forEach(item => {
            this.listShipNo.push({
              name: item.name,
              code: item.code
            })
          })
        })
      }
      //     
      await Promise.all([ship()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },  
    //OK
    drawDescript(descript, pos_x, pos_y){
      // text	
      pos_x = parseInt(pos_x) + 3.0;
      pos_y = parseInt(pos_y) + 6.0;
      
      this.context.save();
      this.context.fillStyle = "black";									
      this.context.font = "12px";
      this.context.textAlign = 'left';								    
      this.context.textBaseline = 'top';
      this.context.fillText(descript, pos_x, pos_y);
      this.context.restore();    	
          
    }, //drawDescript Ending
    //OK
    drawDescriptTitle(descript, pos_x, pos_y, length, height){
      pos_x = parseInt(pos_x) + 3.0;
      pos_y = parseInt(pos_y) + 6.0;
        
      this.context.save();
      this.context.fillStyle = "blue";									
      this.context.font = "24px"; //"13px";
      this.context.textAlign = 'left';								    
      this.context.textBaseline = 'top';
      this.context.fillText(descript, pos_x, pos_y);
      this.context.restore()
              
    }, //drawDescriptTitle Ending
    //CAPACITY --SQL OnBlkQtyRetrieve OK
    DrawCapacity(){ 

      let  li_t_top  = 680;//550
      let  li_t_botm = 600;
      let  li_left   = 50;
      let  li_right  = 60;
      let  iCellHeight= 25;
      
      let i = 0 ;
      
      this.drawText("CAPACITY", li_left + 145, li_t_top + 10, "m_fntmainjob", "black", "1" );//STOCK LOAD STATUS
      
      li_t_top  = li_t_top + 50;
      li_t_botm = li_t_botm + 45;
      
      this.context.save();
      
      this.context.beginPath();
      this.context.lineWidth = 1.0;
      this.context.strokeStyle = "black";
      this.context.rect(li_left - 40, li_t_top - 15 , li_right + 320, 50);
      this.context.fillStyle = "#99FFFF";
      this.context.fill();
      this.context.stroke();
      
      this.drawText("BAY", li_left - 15, li_t_top, "m_fntRemark", "black", "1" );
      
      this.context.beginPath();
      this.context.moveTo(li_left + 10, li_t_top - 15);
      this.context.lineTo(li_left + 10, li_t_top + 35) ;
      
      this.drawText("Lot", li_left + 50, li_t_top - 6,    "m_fntRemark", "black", "1" );
      this.drawText("Number", li_left + 50, li_t_top + 6, "m_fntRemark", "black", "1" );
      
      this.context.moveTo(li_left + 90, li_t_top - 15);
      this.context.lineTo(li_left + 90, li_t_top + 35) ;
      
      this.drawText("Dont", li_left + 110, li_t_top - 12, "m_fntRemark", "black", "1" );
      this.drawText("Use",  li_left + 110, li_t_top,      "m_fntRemark", "black", "1" );
      this.drawText("Area", li_left + 110, li_t_top + 12,  "m_fntRemark", "black", "1" );
      
      this.context.moveTo(li_left + 130, li_t_top - 15);
      this.context.lineTo(li_left + 130, li_t_top + 35) ;
      
      this.context.rect(li_left + 130, li_t_top - 15 , 80, 50);
      this.context.fillStyle = "#99FF99";
      this.context.fill();
      
      this.drawText("Actual", li_left + 170, li_t_top - 6, "m_fntRemark", "black", "1" );
      this.drawText("Use",    li_left + 170, li_t_top + 6, "m_fntRemark", "black", "1" );
      
      this.context.moveTo(li_left + 210, li_t_top - 15);
      this.context.lineTo(li_left + 210, li_t_top + 35) ;
      
      this.drawText("Crane P/E", li_left + 250, li_t_top , "m_fntRemark", "black", "1" );
      
      this.context.moveTo(li_left + 290, li_t_top - 15);
      this.context.lineTo(li_left + 290, li_t_top + 35) ;
      
      this.drawText("T/P P/E", li_left + 315, li_t_top , "m_fntRemark", "black", "1" );
    
      this.context.stroke();      
      this.context.save();

      let params = {strStartDate: this.selectedDate,      } 
      onBlkQtyRetrieve(params)
          .then(res => {  
            // console.log("DrawCapacity...", res.list); 
            if (res.list.length > 0){
                
              let str;
              let rect_left = 0;
              let rect_top  = 0;
              let Start_PosX = 0;
              let Start_PosY = 0;
              
              Start_PosX = 10;
              Start_PosY = li_t_top + 35;
              
              this.cur_y = Start_PosY + res.list.length * iCellHeight;
              
              this.context.beginPath();
              this.context.rect(Start_PosX, Start_PosY + (res.list.length - 1)*iCellHeight , li_right + 320, iCellHeight);
              this.context.fillStyle = "#99FF99";
              this.context.fill();
              this.context.stroke();
                
              for(i= 0; i < res.list.length ; i++) {
                  
                let blockQtyList = {};
                  
                blockQtyList.posgrp  = res.list[i].posgrp;
                blockQtyList.tot      = res.list[i].tot;
                blockQtyList.dontuse = res.list[i].dontuse;
                blockQtyList.used     = res.list[i].used;
                blockQtyList.crane    = res.list[i].crane;
                blockQtyList.tp       = res.list[i].tp;
                
                str = blockQtyList.posgrp ; //Position Group

                if(str === null) str = "";
                rect_left = Start_PosX  + Math.ceil(50/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 50, rect_top);
                this.context.lineTo(Start_PosX + 50, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                this.context.beginPath();
                this.context.moveTo(Start_PosX , rect_top);
                this.context.lineTo(Start_PosX , rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                  
                str = String(blockQtyList.tot) ; 
                if(str === null) str = "";
                rect_left = Math.ceil((Start_PosX + 50 + Start_PosX + 130)/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 130, rect_top);
                this.context.lineTo(Start_PosX + 130, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                
                str = String(blockQtyList.dontuse) ; 
                if(str === null) str = "";
                rect_left = Math.ceil((Start_PosX + 130 + Start_PosX + 170)/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 170, rect_top);
                this.context.lineTo(Start_PosX + 170, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                
                this.context.rect(li_left + 130, Start_PosY +  i*iCellHeight , 80, iCellHeight);
                this.context.fillStyle = "#99FF99";
                this.context.fill();
                
                str = String(blockQtyList.used) ; 
                if(str === null) str = "";
                rect_left = Math.ceil((Start_PosX + 170 + Start_PosX + 250)/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 250, rect_top);
                this.context.lineTo(Start_PosX + 250, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                
                str = String(blockQtyList.crane) ; 
                if(str === null) str = "";
                rect_left = Math.ceil((Start_PosX + 250 + Start_PosX + 330)/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 330, rect_top);
                this.context.lineTo(Start_PosX + 330, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                
                str = String(blockQtyList.tp ) ; 
                if(str === null) str = "";
                rect_left = Math.ceil((Start_PosX + 330 + Start_PosX + 380)/2) - 2;
                rect_top  = Start_PosY +  i*iCellHeight;
                this.drawText(str, rect_left, rect_top + 5, "m_fntRemark", "black", "1"); 
                this.context.beginPath();
                this.context.moveTo(Start_PosX + 380, rect_top);
                this.context.lineTo(Start_PosX + 380, rect_top + iCellHeight) ;
                this.context.stroke();
                //this.context.closePath();
                
                this.context.beginPath();
                this.context.moveTo(Start_PosX , rect_top + iCellHeight);
                this.context.lineTo(Start_PosX + 380, rect_top + iCellHeight) ;
                
                this.context.stroke();
                //this.context.closePath();
                    
              }
            }
          });
  
      this.cur_x = 10;
			 
		}, //DrawCapacity ending
    //STOCK LOAD STATUS --SQL GetBlkCnt OK
		drawStockLoadStatus(){ 
		   
      let li_t_top, li_t_botm, li_c_top, li_c_botm, li_height, li_left, li_right, li_ttle_hght, li_ttle_width;
      let str;
		   		
      li_t_top  = 1100;//920
      li_t_botm = li_t_top + 25;
      li_left   = 10;
      li_right  = 60;
      li_ttle_hght = 25;
      li_ttle_width = 400;


      this.context.fillStyle = "#99FFFF";
      this.context.fillRect(li_left, li_t_top, li_ttle_width, li_ttle_hght*2);//0,0
      
      this.context.strokeStyle = "black";
      this.context.lineWidth = 1;
      this.context.font = "normal 14px Arial";
      this.context.fillStyle = "black";
      //Add more
      this.context.textAlign = "center";
      this.context.textBaseline = "middle";
      
      // Header
      this.context.strokeRect(li_left, li_t_top, li_ttle_width, li_ttle_hght*2);//
      this.drawText("STOCK LOAD STATUS", li_left + li_ttle_width / 2,  li_t_top - 25, "m_fntmainjob", "black", "1"); 
      
      // Column headers with rowspan = 2
      const headers = [
        "Capacity", "Load", "%(B/A)"
      ];
      const widths = [160, 160];
      let x = li_left;
      let y = 1100;
      //Hiển thị 2 cột Capacity, Load
      headers.forEach((header, index) => {
        this.context.strokeRect(x, y, widths[index], li_ttle_hght); // Rowspan effect
        this.drawText(header, x + widths[index] / 2, y + 5, "m_fntRemark", "black", "1"); 
        x += widths[index];
      });
      
      x = li_left + 320 + 40;
      // Hiển thị cột %(B/A)
      this.drawText("%(B/A)",  x, y + 18, "m_fntRemark", "black", "1"); 
      
      // Sub-columns for Stock load status
      let subHeaders = ["Total", "Use(A)", "Plan","Actual"];
      let subWidths = [80, 80, 80, 80];
      y += 25;
      let x1 = li_left;
      subHeaders.forEach((subHeader, index) => {
        this.context.strokeRect(x1, y, subWidths[index], li_ttle_hght);
        this.drawText(subHeader,  x1 + subWidths[index] / 2, y + 5, "m_fntRemark", "black", "1"); 
        x1 += subWidths[index];
      }); 
        
      let params = {strStartDate: this.selectedDate,      } 
      getBlkCnt(params)
        .then((res) => {  
            // console.log("drawStockLoadStatus...", res.list); 
          if (res.list.length > 0){
	    			// Lấy dòng đầu tiên từ danh sách
            const firstRow = res.list[0];
            // Trích xuất giá trị từ các cột b100, b200, b300, b400, b500
            this.StockData[0] = [
              firstRow.b100,
              firstRow.b200,
              firstRow.b300,
              firstRow.b400,
              firstRow.b500,
            ];

            // console.log("Dữ liệu đã cập nhật:", this.StockData[0]);
            // Vẽ dữ liệu
            let x2 = li_left;
            y += 25;
            // this.context.fillStyle = "white"; // Màu nền ô dữ liệu
            this.StockData[0].forEach((text, i) => {
              // this.context.fillRect(x2, y, 80, 25);
              this.context.strokeRect(x2, y, 80, 25);
              this.context.fillStyle = "black";
              this.context.fillText(text, x2 + 80 / 2, y + 13);
              x2 += 80;
            });

	    		}
        })
        .catch((error) => {
          console.error("Lỗi khi gọi API:", error);  
	    	});
      
		}, //drawStockLoadStatus ending
    //PLATFORM USING STATUS --SQL OnFlatFormListRetrieve OK
		drawFlatFormList(){
		   
      let li_ttle_top, li_t_top, li_c_top, li_height, li_left, li_ttle_hght, li_ttle_width, str;
		   	    
      li_ttle_top   = 55;// 920 + 18*25 + 20 ==>18: là số hàng của CAPTION
      li_t_top      = li_ttle_top + 25; //30
      li_left       = 10;
      li_ttle_hght  = 40;
      li_ttle_width = 430;
      
      this.drawText("PLATFORM USING STATUS", li_left + 215 , li_ttle_top , "m_fntmainjob", "black", "1") ;
      
      this.context.beginPath();
      this.context.fillStyle = "#99FFFF";
      this.context.fillRect(li_left , li_t_top , li_ttle_width, li_ttle_hght);
			    
      this.context.beginPath();
      this.context.rect(li_left , li_t_top , li_ttle_width, li_ttle_hght);
      this.context.stroke();
			    
      this.context.beginPath();
      this.context.moveTo(li_left + 50, li_t_top);
      this.context.lineTo(li_left + 50, li_t_top + li_ttle_hght);
      
      this.context.moveTo(li_left + 130, li_t_top);
      this.context.lineTo(li_left + 130, li_t_top + li_ttle_hght);
      
      this.context.moveTo(li_left + 210, li_t_top);
      this.context.lineTo(li_left + 210, li_t_top + li_ttle_hght);
      
      this.context.moveTo(li_left + 330, li_t_top);
      this.context.lineTo(li_left + 330, li_t_top + li_ttle_hght);
      
      this.context.moveTo(li_left + 380, li_t_top);
      this.context.lineTo(li_left + 380, li_t_top + li_ttle_hght);
      
      this.drawText("Flat", li_left + 25 , li_t_top + 10 - 6, "m_fntRemark", "black", "1") ;
      this.drawText("Form", li_left + 25 , li_t_top + 10 + 6, "m_fntRemark", "black", "1") ;
      
      this.drawText("Size", li_left + 90 , li_t_top + 10 , "m_fntRemark", "black", "1") ;
      
      this.drawText("Weight", li_left + 170 , li_t_top + 10 - 6 , "m_fntRemark", "black", "1") ;
      this.drawText("(Ton)" , li_left + 170 , li_t_top + 10 + 6 , "m_fntRemark", "black", "1") ;
      
      this.drawText("Block",  li_left + 270 , li_t_top + 10 , "m_fntRemark", "black", "1") ;
      
      this.drawText("Start",  li_left + 355 , li_t_top + 10 - 6, "m_fntRemark", "black", "1") ;
      this.drawText("Date",   li_left + 355 , li_t_top + 10 + 6, "m_fntRemark", "black", "1") ;
      
      this.drawText("Remark", li_left + 405 , li_t_top + 10 , "m_fntRemark", "black", "1") ;
      
      this.context.stroke();
		     		
      let params = {strStartDate: this.selectedDate,      } 
      onFlatFormListRetrieve(params)
        .then(res => {  
            // console.log("drawFlatFormList...", res.list); 
          if (res.list.length > 0){
	    				
            var i;
            li_c_top  = li_t_top + 40;
            li_height = 25;
	    				
            for(i= 0; i < res.list.length ; i++) {
							
							let FlatFormList = {};
							
              FlatFormList.objid     = res.list[i].objid;
              FlatFormList.objnm     = res.list[i].objnm;
              FlatFormList.objwth    = res.list[i].objwth;
              FlatFormList.objhgt    = res.list[i].objhgt;
              FlatFormList.objlen    = res.list[i].objlen;
              FlatFormList.objwgt    = res.list[i].objwgt;
              FlatFormList.usedept   = res.list[i].usedept;
              FlatFormList.frdt      = res.list[i].frdt;
              FlatFormList.todt      = res.list[i].todt;
              FlatFormList.status    = res.list[i].status;
              FlatFormList.rmk       = res.list[i].rmk;
	    					
              this.context.beginPath();
	    					
              str = FlatFormList.objnm ;
							if(str == null) str = "";
							this.drawText(str, li_left + 25, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left , li_c_top);
              this.context.lineTo(li_left , li_c_top + (i+1)*li_height);
              this.context.moveTo(li_left + 50, li_c_top);
              this.context.lineTo(li_left + 50, li_c_top + (i+1)*li_height);
							
							str = FlatFormList.objlen + "x" + FlatFormList.objwth + "(m)" ;
							if(str == null) str = "";
							this.drawText(str, li_left + 90, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left + 130, li_c_top);
              this.context.lineTo(li_left + 130, li_c_top + (i+1)*li_height);
							
							str = FlatFormList.objwgt ;
							if(str == null) str = "";
							this.drawText(str, li_left + 170, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left + 210, li_c_top);
              this.context.lineTo(li_left + 210, li_c_top + (i+1)*li_height);
							
							str = FlatFormList.status ;
							if(str == null) str = "";
							this.drawText(str, li_left + 270, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left + 330, li_c_top);
              this.context.lineTo(li_left + 330, li_c_top + (i+1)*li_height);
							
							str = FlatFormList.frdt ;
							if(str == null) str = "";
							this.drawText(str, li_left + 355, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left + 380, li_c_top);
              this.context.lineTo(li_left + 380, li_c_top + (i+1)*li_height);
							
							str = FlatFormList.rmk ;
							if(str == null) str = "";
							this.drawText(str, li_left + 405, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
							this.context.moveTo(li_left + 430, li_c_top);
              this.context.lineTo(li_left + 430, li_c_top + (i+1)*li_height);
              
              this.context.moveTo(li_left , li_c_top + (i+1)*li_height);
              this.context.lineTo(li_left + 430, li_c_top + (i+1)*li_height);
							
							this.context.stroke();
	    			};
	    				
	    		}
	      });
			    				
		}, //drawFlatFormList ending
    // Định nghĩa màu OK
    drawExample() {
        let li_left = 1930;
        let li_top  = 1400;//1200//1900
        let ll_cnt  = 0;
        // this.context.beginPath();
        // this.context.rect(li_left, li_top, 270, 350);
        // this.drawText("COLOR REMARK", li_left + 30, li_top + 5, "m_fntmainjob", "black", "0");
        //Dựa vào https://imagecolorpicker.com/color-code/448ccb --> để lấy thông tin màu
        const colors = [
            { color: "#dcdcdc", label: "UNIT BLK" },//≈ Alto
            { color: "#e2f7df", label: "Finished Unit, Stand by PE" },//≈ Peppermint
            { color: "#f5f0c5", label: "1st PE BLK" },//≈ Sidecar
            { color: "#a0e697", label: "Finished 1st PE, Work Pre-Out." },//≈ Granny Smith Apple
            { color: "#ffd7ae", label: "Finished Pre-Out., Work 1st PE" },//≈ Caramel
            { color: "#b1d09f", label: "Finished PE/Pre-Out., Wait Paint." },//≈ Sprout
            { color: "#e2a6b4", label: "Painting BLK" },//≈ Shilo
            { color: "#9ecfcf", label: "Finished Paint., Wait 2nd PE" },//≈ Sinbad
            { color: "#bea3c9", label: "2nd PE BLK/ 2nd Pre-Out" },//≈ London Hue
            { color: "#999be6", label: "Standby For Erection" },//≈ Dull Lavender
            { color: "#448ccb", label: "Erection BLK" },//≈ Shakespeare
        ];
        
        colors.forEach((item, index) => {
            this.drawColorBlock(li_left + 10, li_top + 30 + index * 25, item.color, item.label);
            ll_cnt = index
        });
        // console.log('cnt: ',ll_cnt);
        let textureCanvas = this.$refs.textureCanvas;
        let patImg = this.context.createPattern(textureCanvas, "repeat");        
        this.drawPatternBox(li_left + 10, li_top + (ll_cnt*30) + 5, 15);
        this.drawColorBlock(li_left + 10, li_top + (ll_cnt*30) + 5, patImg, "Don't Use");
        
        this.context.beginPath();
        this.context.rect(li_left, li_top, 270, 330);
        this.drawText("COLOR REMARK", li_left + 30, li_top + 5, "m_fntmainjob", "black", "0");
        this.context.stroke();
    },    
    drawColorBlock(x, y, fillStyle, label) {
        this.context.strokeStyle = "black";
        this.context.fillStyle = fillStyle;
        this.context.strokeRect(x, y, 15, 15);//fillRect
        this.context.fillRect(x, y, 15, 15)
        this.context.rect(x, y, 15, 15);
        this.drawText(label, x + 25, y - 3, "m_fntmainjob", "black", "0");
    },   
    drawPatternBox(x,y,size) {
        // let x = 80;
        // let y = 0;
        // let size = 40;
        
        this.context.beginPath();
        this.context.rect(x, y, size, size);
        this.context.stroke();
        
        // Vẽ các đường gạch chéo bên trong ô vuông
        let step = 5;
        for (let i = 0; i <= size; i += step) {
            this.context.beginPath();
            this.context.moveTo(x + i, y);
            this.context.lineTo(x, y + i);
            this.context.stroke();
        }

        for (let i = step; i <= size; i += step) {
            this.context.beginPath();
            this.context.moveTo(x + size, y + i);
            this.context.lineTo(x + i, y + size);
            this.context.stroke();
        }
    }, 
    //BLOCK SUPPORT & BOX BEAM STATUS --SQL OnBlkSuppBeamRetrieve  OK 
    DrawBlkSuppBeam() {
      let li_left = 500;
      let li_t_top = 55;
      let li_c_top = li_t_top + 25;
      let li_height = 25;
      let li_c_botm = li_c_top + 50;

      const drawTextAt = (text, x, y) => this.drawText(text || "", x, y, "m_fntRemark", "black", "1");

      // Header
      this.drawText("BLOCK SUPPORT & BOX BEAM STATUS", li_left + 200, li_t_top, "m_fntmainjob", "black", "1");
      
      this.context.fillStyle = "#99FFFF";
      this.context.fillRect(li_left, li_t_top + 25, 380, 50);
      
      this.context.beginPath();
      this.context.rect(li_left, li_t_top + 25, 380, 50);

      // Column headers
      drawTextAt("Classify", li_left + 50, li_c_top + 20);
      
      drawTextAt("Size", li_left + 140, li_c_top + 10);
      drawTextAt("(M)", li_left + 140, li_c_top + 25);

      drawTextAt("Load", li_left + 200, li_c_top);
      drawTextAt("WGT", li_left + 200, li_c_top + 15);
      drawTextAt("(Max)", li_left + 200, li_c_top + 30);

      drawTextAt("Present", li_left + 250, li_c_top + 10);
      drawTextAt("Qty", li_left + 250, li_c_top + 25);

      drawTextAt("Remark", li_left + 330, li_c_top + 20);

      // Draw vertical lines
      [100, 180, 220, 280, 380].forEach(x => {
          this.context.moveTo(li_left + x, li_c_top);
          this.context.lineTo(li_left + x, li_c_top + 50);
      });

      this.context.stroke();

      let params = { strStartDate: this.selectedDate };
      onBlkSuppBeamRetrieve(params).then(res => {
          if (res.list.length > 0) {
              let li_cur_cnt = 0, li_next_cnt = 0;

              this.context.beginPath();
              
              res.list.forEach(({
                  objectnm, weight, qtytot, rmk, objecttype
              }, i) => {
                  if (objecttype === "BS") li_cur_cnt++;
                  if (objecttype === "BB") li_next_cnt++;

                  let yPos = li_c_botm + i * li_height + 5;

                  drawTextAt(objectnm, li_left + 140, yPos);
                  drawTextAt(weight, li_left + 200, yPos);
                  drawTextAt(qtytot, li_left + 250, yPos);
                  drawTextAt(rmk, li_left + 330, yPos);

                  // Vertical lines for each row
                  [li_left, li_left + 100, li_left + 180, li_left + 220, li_left + 280, li_left + 380].forEach(x => {
                      this.context.moveTo(x, li_c_botm);
                      this.context.lineTo(x, li_c_botm + (i + 1) * li_height);
                  });

                  // Horizontal line at row bottom
                  this.context.moveTo(li_left + 100, li_c_botm + (i + 1) * li_height);
                  this.context.lineTo(li_left + 380, li_c_botm + (i + 1) * li_height);
              });

              // Draw "BLK SUPP" and "BOX BEAM" labels
              if (li_cur_cnt > 0) {
                  drawTextAt("BLK SUPP", li_left + 50, li_c_botm + (li_cur_cnt - 1) * li_height / 2 + 5);
                  this.context.moveTo(li_left, li_c_botm + li_cur_cnt * li_height);
                  this.context.lineTo(li_left + 100, li_c_botm + li_cur_cnt * li_height);
              }

              if (li_next_cnt > 0) {
                  drawTextAt("BOX BEAM", li_left + 50, li_c_botm + li_cur_cnt * li_height + (li_next_cnt - 1) * li_height / 2 + 5);
                  this.context.moveTo(li_left, li_c_botm + (li_cur_cnt + li_next_cnt) * li_height);
                  this.context.lineTo(li_left + 100, li_c_botm + (li_cur_cnt + li_next_cnt) * li_height);
              }

              this.context.stroke();
          }
      });
    },
    DrawBlkSuppBeam1(){
           
      let li_t_top, li_t_botm, li_c_top, li_c_botm, li_height, li_left, li_right, str;
      
      li_left = 500;//
      li_t_top = 55;//
      li_c_top = li_t_top + 25;
      
      this.drawText("BLOCK SUPPORT & BOX BEAM STATUS", li_left + 225, li_t_top , "m_fntmainjob", "black", "1");
      
      this.context.beginPath();
      this.context.fillStyle = "#99FFFF"; 
      this.context.fillRect(li_left, li_t_top + 25, 380, 50);//450
      
      this.context.beginPath();
      this.context.rect(li_left, li_t_top + 25, 380, 50);
      
      this.drawText("Classify", li_left + 50, li_c_top + 20 , "m_fntRemark", "black", "1");
      
      this.context.moveTo(li_left + 100, li_c_top);//w:100
      this.context.lineTo(li_left + 100, li_c_top + 50);
      
      this.drawText("Size", li_left + 140, li_c_top + 20 - 6 , "m_fntRemark", "black", "1");
      this.drawText("(M)", li_left + 140, li_c_top + 20 + 6 , "m_fntRemark", "black", "1");
      
      this.context.moveTo(li_left + 180, li_c_top);//w:80
      this.context.lineTo(li_left + 180, li_c_top + 50);
      
      this.drawText("Load", li_left + 200, li_c_top + 20 - 20 , "m_fntRemark", "black", "1");
      this.drawText("WGT", li_left + 200, li_c_top + 20 -5  , "m_fntRemark", "black", "1");
      this.drawText("(Max)", li_left + 200, li_c_top + 20 + 10 , "m_fntRemark", "black", "1");
      
      this.context.moveTo(li_left + 220, li_c_top);//w:40
      this.context.lineTo(li_left + 220, li_c_top + 50);
      
      this.drawText("Present", li_left + 250, li_c_top + 20 - 6 , "m_fntRemark", "black", "1");//220 + 30
      this.drawText("Qty", li_left + 250, li_c_top + 20 + 6 , "m_fntRemark", "black", "1");
      //Hor end line Pre' qty
      this.context.moveTo(li_left + 280, li_c_top);//60
      this.context.lineTo(li_left + 280, li_c_top + 50);
      
      this.context.moveTo(li_left + 380, li_c_top);//380
      this.context.lineTo(li_left + 380, li_c_top + 50);
      
      this.drawText("Remark", li_left + 330, li_c_top + 20 , "m_fntRemark", "black", "1");//80
      
      this.context.stroke();
		     		
    	let params = {strStartDate: this.selectedDate,      } 
      onBlkSuppBeamRetrieve(params)
        .then(res => {  
          // console.log("DrawBlkSuppBeam...", res.list); 
          if (res.list.length > 0){	    				
            var i;
            var li_cur_cnt = 0, li_next_cnt = 0; 
            li_c_botm  = li_c_top + 50;
            li_height = 25;
            
            this.context.beginPath();
	    				
            for(i= 0; i < res.list.length ; i++) {
							
							var BlkSuppBeam = new Object();
							
	    					BlkSuppBeam.objtype    = res.list[i].objtype;
	    					BlkSuppBeam.objectnm   = res.list[i].objectnm;
	    					BlkSuppBeam.objecttype = res.list[i].objecttype;
	    					BlkSuppBeam.weight     = res.list[i].weight;
	    					BlkSuppBeam.qtytot     = res.list[i].qtytot;
	    					BlkSuppBeam.qtyused    = res.list[i].qtyused;
	    					BlkSuppBeam.qtyremain  = res.list[i].qtyremain;
	    					BlkSuppBeam.rmk        = res.list[i].rmk;
	    					
              if(BlkSuppBeam.objecttype =="BS") {
								li_cur_cnt++ ;
							}
					
							if(BlkSuppBeam.objecttype =="BB") {
								li_next_cnt++ ;
							} 
	    				
							this.context.moveTo(li_left , li_c_botm);
              this.context.lineTo(li_left , li_c_botm + (i+1)*li_height);
              this.context.moveTo(li_left + 100, li_c_botm);
              this.context.lineTo(li_left + 100, li_c_botm + (i+1)*li_height);
              
              str = BlkSuppBeam.objectnm ;
							if(str == null) str = "";
							this.drawText(str, li_left + 140, li_c_botm + i*li_height + 5, "m_fntRemark", "black", "1");
              this.context.moveTo(li_left + 180, li_c_botm);
              this.context.lineTo(li_left + 180, li_c_botm + (i+1)*li_height);
              
              str = BlkSuppBeam.weight ;
							if(str == null) str = "";
							this.drawText(str, li_left + 200, li_c_botm + i*li_height + 5, "m_fntRemark", "black", "1");
              this.context.moveTo(li_left + 220, li_c_botm);
              this.context.lineTo(li_left + 220, li_c_botm + (i+1)*li_height);
              
              str = BlkSuppBeam.qtytot ;
							if(str == null) str = "";
							this.drawText(str, li_left + 250, li_c_botm + i*li_height + 5, "m_fntRemark", "black", "1");//
              this.context.moveTo(li_left + 280, li_c_botm);//
              this.context.lineTo(li_left + 280, li_c_botm + (i+1)*li_height);//

              str = BlkSuppBeam.rmk ;
							if(str == null) str = "";
							this.drawText(str, li_left + 330, li_c_botm + i*li_height + 5, "m_fntRemark", "black", "1");//
              this.context.moveTo(li_left + 380, li_c_botm);//
              this.context.lineTo(li_left + 380, li_c_botm + (i+1)*li_height);//
              
              this.context.moveTo(li_left + 100, li_c_botm + (i+1)*li_height);// Each row bottom line
              this.context.lineTo(li_left + 380, li_c_botm + (i+1)*li_height);//
			   			};
			   			
			   			if(li_cur_cnt > 0){
							this.drawText("BLK SUPP", li_left + 50, li_c_botm + (li_cur_cnt-1)*li_height/2 + 5, "m_fntRemark", "black", "1");
							
							this.context.moveTo(li_left     , li_c_botm + li_cur_cnt*li_height);
              this.context.lineTo(li_left + 100, li_c_botm + li_cur_cnt*li_height);
					
						}
					
						if(li_next_cnt > 0){
							this.drawText("BOX BEAM", li_left + 50, li_c_botm + li_cur_cnt*li_height + (li_next_cnt - 1)*li_height/2 + 5, "m_fntRemark", "black", "1");
							
							this.context.moveTo(li_left     , li_c_botm + (li_cur_cnt + li_next_cnt)*li_height);
              this.context.lineTo(li_left + 100, li_c_botm + (li_cur_cnt + li_next_cnt)*li_height);
					
						}			   			
            this.context.stroke();
          }
        });           
    },
    //OK
    drawBorder() {
      // console.log("Drawing border...");
      let strTmpDate = this.selectedDate          	
      let chkDate = new Date(strTmpDate) ;
      let weekdays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"] ;
      
      let strSaveDate = "" ;
      let strSaveUID = "" ;
      let str = "" ;
      
      this.context.save();
      this.context.beginPath() ;
      this.context.strokeStyle = "black";
      this.context.lineWidth = 2.0;

      this.context.moveTo(0 , this.top_y);
      this.context.lineTo(2300, this.top_y);
      this.context.lineTo(2300, 2500);//1800//2000
      this.context.lineTo(0, 2500);//1800//2000
      this.context.lineTo(0, this.top_y); 					
      this.context.stroke() ;	
      this.context.closePath();
      
      this.context.moveTo(1900 , 0);//1800//1900
      str = strTmpDate + " [" + weekdays[chkDate.getDay()] + "]/[DAY]" ; 
      this.drawText(str, 1900, 10, "m_fntRemark", "black", "0");//2000//1900

      let params = {strStartDate: this.selectedDate,}

      getLastConfirm(params)
        .then(res => {  
          // console.log("drawBorder...", res.list)
          if (res.list.length > 0){
            strSaveDate =  res.list[0].savedt
            strSaveUID  =  res.list[0].usrnm
            
            str = "LAST UPDATE: " + strSaveDate + " (" + strSaveUID + ")" ;
            //drawText(str, 2000, 25, "m_fntRemark", "black", "0");        
          }else {
            str = "P/P Has not confirm yet"                
          }        
          this.drawText(str, 1900, 25, "m_fntRemark", "black", "0");//2000//1900
      
        }); // request done end */      
        this.context.restore();      
    },
    //OK
    drawYard(){      
    		  	 
      let DockGate = ['D','O','C','K','G','A','T','E'] ;
    		  	 
      let textureCanvas = this.$refs.textureCanvas;//document.getElementById('textureCanvas');
      let textureContext = textureCanvas.getContext('2d');
          textureContext.fillStyle = 'grey';
          textureContext.fillRect(0, 0, 2, 1);
          textureContext.fillStyle = 'lightgrey';
          textureContext.fillRect(2, 0, 1, 1);
          textureContext.fillStyle = 'grey';
          textureContext.fillRect(1, 0, 1, 1); 

			// console.log("F. this.drawYard...", this.YardObjList); 	 
      this.YardObj_Cnt = this.YardObjList.length ;	
      for(let i=0 ; i < this.YardObj_Cnt; i++) {
				 
        let strLOC = ""	;
        let strDESCRIPT = "" ;
        let strSTATUS = "" ;  
        let r = 255 ;
        let g = 255 ; 
        let b = 255 ;       		
        let intGON;
        let rText, gText, bText ;
        let rLine, gLine, bLine ;  	
        let strPosDiv = "";
        let strLineColor = "" ;
								
        strLOC 		= this.YardObjList[i].acode;
        r     	  = this.YardObjList[i].colorr;
        g     	  = this.YardObjList[i].colorg;
        b     		= this.YardObjList[i].colorb;	
        intGON 		= this.YardObjList[i].gon;	
        
        strDESCRIPT = this.YardObjList[i].descript;
        strSTATUS   = this.YardObjList[i].status;
        
        rText 		= this.YardObjList[i].textcolorr;
        gText 		= this.YardObjList[i].textcolorg;
        bText 		= this.YardObjList[i].textcolorb;
      
        rLine 		= this.YardObjList[i].linecolorr;
        gLine 		= this.YardObjList[i].linecolorg;
        bLine 		= this.YardObjList[i].linecolorb;

        // console.log("strLOC...", this.YardObjList[i].gon); 	 
        strPosDiv	= this.YardObjList[i].posdiv ;
        strLineColor = String(rLine) + String(gLine) + String(bLine) ;
					
        let strBGCOLOR = String(r) + String(g) + String(b) ;
        
        let YardObjSub_X = [0, 0, 0, 0, 0, 0] ;
        let YardObjSub_Y = [0, 0, 0, 0, 0, 0] ; 
          
        YardObjSub_X[0] = this.YardObjList[i].posx01 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[0] = this.YardObjList[i].posy01 * this.zoom/100 ;
        
        YardObjSub_X[1] = this.YardObjList[i].posx02 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[1] = this.YardObjList[i].posy02 * this.zoom/100 ;
        
        YardObjSub_X[2] = this.YardObjList[i].posx03 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[2] = this.YardObjList[i].posy03 * this.zoom/100 ;
			 		
        YardObjSub_X[3] = this.YardObjList[i].posx04 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[3] = this.YardObjList[i].posy04 * this.zoom/100 ;
        
        YardObjSub_X[4] = this.YardObjList[i].posx05 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[4] = this.YardObjList[i].posy05 * this.zoom/100 ;
        
        YardObjSub_X[5] = this.YardObjList[i].posx06 * this.zoom/100 + this.prt_margin;
        YardObjSub_Y[5] = this.YardObjList[i].posy06 * this.zoom/100 ;
				// console.log("Test...", this.YardObjList[i].posx01);  		
        for(let j= 0 ; j< 6 ; j++) {
			 		 
          let ll_xx = YardObjSub_Y[j];
          let ll_yy = YardObjSub_Y[j];
          
          if(this.Max_X < ll_xx) {
            this.Max_X = ll_xx  ;
          } ;
                
          if(this.Max_Y < ll_yy) {
            this.Max_Y = ll_yy ;
          } ;
        }
					
        this.context.save() ;
					
        if (strLineColor === "000" && (strLOC.substr(0,1) != "O" || strLOC.substr(0,3) === "OUT")){
				 	
          this.context.beginPath() ; 	
          this.context.strokeStyle = "rgb(" + rLine + "," + gLine + "," + bLine + ")" ;  
          this.context.lineWidth = 0.5 ;
          
          if(strPosDiv === "D" && strLOC.substr(0, 1) != "O" ){
            	  
            let patImg = this.context.createPattern(textureCanvas, "repeat");	           
            this.context.fillStyle = patImg ;   	   
          }
          else { 
          
            let strBG_RGB = "rgb(" + r + "," + g + "," + b + ")" ; 
            this.context.fillStyle = strBG_RGB ;	
          };  
					
          if ( strSTATUS === "D" ){
								
          }else{
            this.context.moveTo(YardObjSub_X[0], YardObjSub_Y[0]) ;
            this.context.lineTo(YardObjSub_X[1], YardObjSub_Y[1]) ;
            this.context.lineTo(YardObjSub_X[2], YardObjSub_Y[2]) ;
            this.context.lineTo(YardObjSub_X[3], YardObjSub_Y[3]) ;
            
            if(YardObjSub_X[4] > 0 || YardObjSub_Y[4] > 0) {
              this.context.lineTo(YardObjSub_X[4], YardObjSub_Y[4]) ;
            } ;
            
            if(YardObjSub_X[5] > 0 || YardObjSub_Y[5] > 0) {
              this.context.lineTo(YardObjSub_X[5], YardObjSub_Y[5]) ;
            } ;
            
            this.context.lineTo(YardObjSub_X[0], YardObjSub_Y[0]) ;
            this.context.stroke();	
            this.context.fill() ;			
            this.context.closePath() ; 	
          }			
        } // End if strLineColor 
				 	
          //strDESCRIPT = strDESCRIPT.trim() ;
				 	
        if(strLOC === "DK01" || strLOC === "DK02") {
            
          this.context.beginPath();
          this.context.moveTo(YardObjSub_X[0], YardObjSub_Y[0]) ;
          this.context.lineTo(YardObjSub_X[0] + 15, YardObjSub_Y[0]);
          this.context.lineTo(YardObjSub_X[1] + 15, YardObjSub_Y[1]);
          this.context.lineTo(YardObjSub_X[1], YardObjSub_Y[1]);
          this.context.lineTo(YardObjSub_X[0], YardObjSub_Y[0]); 
          
          this.context.stroke();
          
          this.context.closePath() ;
          
          let iSpaceChar = 0;
          
          if (strLOC === "DK02") 
            { iSpaceChar = 17; }
          else 
            { iSpaceChar = 11; } 
                
            for(let k= 0 ; k < 8 ; k++)
            {
              
              let charTop = 0;
              let dkChar = DockGate[k] ;
              
              charTop = YardObjSub_Y[0] + iSpaceChar * k ;
              
              this.drawText(dkChar, YardObjSub_X[0], charTop, "m_fntQuayDesc", "black", "0");
            }
        } 
				 	
        if(strDESCRIPT.length >= 1 && strSTATUS != "D" && strPosDiv != "D") {
              
          if(strLOC.substr(0, 1) < "A") {
            
            this.drawText(strDESCRIPT, YardObjSub_X[0] + 0, YardObjSub_Y[0] + 12, "m_fntQuayDesc", "red", "0") ;
          
          }
          else if(strLOC === "DK01" || strLOC === "DK02"){
          
            let dkCenter = YardObjSub_Y[0] + Math.ceil((YardObjSub_Y[1] - YardObjSub_Y[0])/2) ;
          
            this.drawText(strDESCRIPT, YardObjSub_X[0] + 20, dkCenter, "m_fntQuayDesc", "blue", "0") ;
          
          }else {
          
            let dkCenter = YardObjSub_Y[0] + Math.ceil((YardObjSub_Y[1] - YardObjSub_Y[0])/2) - 8 ;
            
            if(strLOC === "X590" || strLOC === "X") {
            
              this.drawText(strDESCRIPT, YardObjSub_X[0], dkCenter , "m_fntQuayDesc", "black", "2") ;
              
            }else if(strLOC.substr(0, 2) === "HA") {
            
              this.drawText(strDESCRIPT, YardObjSub_X[0] + 7, dkCenter , "m_fntQuayDesc", "black", "0") ;
              
            }else{
            
              this.drawText(strDESCRIPT, YardObjSub_X[0], dkCenter , "m_fntQuayDesc", "black", "0") ;
            }	 		
          }
              
        }
				 	
      } // End for loop ll_i

      //Add more 2025.03.20
      if(this.YardObj_Cnt > 0 ){
        this.drawShip();
      }  
      this.context.restore();	
    }, // End draw yard   
    //SHIP MAIN EVENT --SQL OnBlkShipEventRetrieve  OK 
    drawShipEvent(){
           		
      let li_t_top, li_t_botm, li_c_top, li_c_botm, li_height, li_left, li_t_width, li_ttle_top ;
      let li_cur_cnt, li_next_cnt, li_ship_cnt ;

      let str_Cur_Batch, str_Cur_Dock, str ;
           		
      li_ttle_top  = 1750;//1450//1550
      li_t_top     = li_ttle_top + 30;
      //li_t_botm    = 1570;
      li_left      = 1700;//1785
      li_t_width   = 500;
				
      this.drawText("SHIP MAIN EVENT", li_left + 225, li_ttle_top , "m_fntmainjob22", "black", "1");
      
      this.context.beginPath();
      this.context.fillStyle = "#99FFFF";
      this.context.fillRect(li_left, li_t_top, li_t_width, 30);
      
      this.context.beginPath();
      this.context.rect(li_left, li_t_top, li_t_width, 30);
      
      this.drawText("Div", li_left + 20, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 40, li_t_top);
      this.context.lineTo(li_left + 40, li_t_top + 30);
      
      this.drawText("Dock", li_left + 60, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 80, li_t_top);
      this.context.lineTo(li_left + 80, li_t_top + 30);
      
      this.drawText("Batch", li_left + 105, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 130, li_t_top);
      this.context.lineTo(li_left + 130, li_t_top + 30);
      
      this.drawText("Ship", li_left + 155, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 180, li_t_top);
      this.context.lineTo(li_left + 180, li_t_top + 30);
      
      this.drawText("Owner", li_left + 220, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 260, li_t_top);
      this.context.lineTo(li_left + 260, li_t_top + 30);
      
      this.drawText("Type", li_left + 280, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 300, li_t_top);
      this.context.lineTo(li_left + 300, li_t_top + 30);
      
      this.drawText("W/C", li_left + 320, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 340, li_t_top);
      this.context.lineTo(li_left + 340, li_t_top + 30);
      
      this.drawText("K/L", li_left + 360, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 380, li_t_top);
      this.context.lineTo(li_left + 380, li_t_top + 30);
      
      this.drawText("F/T", li_left + 400, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 420, li_t_top);
      this.context.lineTo(li_left + 420, li_t_top + 30);
      
      this.drawText("L/C", li_left + 440, li_t_top + 5 , "m_fntRemark22", "black", "1");
      this.context.moveTo(li_left + 460, li_t_top);
      this.context.lineTo(li_left + 460, li_t_top + 30);
      
      this.drawText("D/L", li_left + 480, li_t_top + 5 , "m_fntRemark22", "black", "1");				
      this.context.stroke();
      
      li_c_top = li_t_top + 30;
      
      li_height = 25;
      str_Cur_Batch = " " ; 
      str_Cur_Dock = " ";
      li_cur_cnt  = 0 ;
      li_next_cnt  = 0 ;

      let params = {strStartDate: this.selectedDate,      } 
      onBlkShipEventRetrieve(params)
        .then(res => {  
          // console.log("drawShipEvent...", res.list); 
          if (res.list.length > 0){	    				
            let i;            
            this.context.beginPath();	    				
            for(i= 0; i < res.list.length ; i++) {
							
							let BlkShipEvent = {};
							
	    					BlkShipEvent.term        = res.list[i].term;
	    					BlkShipEvent.arrgterm   = res.list[i].arrgterm;
	    					BlkShipEvent.dock        = res.list[i].dock;
	    					BlkShipEvent.batchno    = res.list[i].batchno;
	    					BlkShipEvent.ship        = res.list[i].ship;
	    					BlkShipEvent.owner       = res.list[i].owner;
	    					BlkShipEvent.stype      = res.list[i].stype;
	    					BlkShipEvent.wcdate     = res.list[i].wcdate;
	    					BlkShipEvent.kldate     = res.list[i].kldate;
	    					BlkShipEvent.ftdate     = res.list[i].ftdate;
	    					BlkShipEvent.lcdate     = res.list[i].lcdate;
	    					BlkShipEvent.dldate     = res.list[i].dldate;
	    					BlkShipEvent.kl          = res.list[i].kl;
	    					BlkShipEvent.lc          = res.list[i].lc;
	    					BlkShipEvent.ft          = res.list[i].ft;
	    					BlkShipEvent.colorstyle    = res.list[i].colorstyle;
	    					BlkShipEvent.shippattern   = res.list[i].shippattern;
	    					BlkShipEvent.shipcnt       = res.list[i].shipcnt;

							if(BlkShipEvent.term ==="1") {
								li_cur_cnt++ ;
							}
					
							if(BlkShipEvent.term ==="2") {
								li_next_cnt++ ;
							}
							
							if((str_Cur_Batch === BlkShipEvent.term) && (str_Cur_Dock === BlkShipEvent.dock) ){			
	
							}
							else{
								li_ship_cnt = BlkShipEvent.shipcnt;
								str = BlkShipEvent.dock ;
								if(str === null) str = "";
								this.drawText("#" + str, li_left + 60, li_c_top + i*li_height + (li_ship_cnt-1)*li_height/2 + 5, "m_fntRemark", "black", "1");
								
                this.context.moveTo(li_left + 40, li_c_top + i*li_height);
                this.context.lineTo(li_left + 80, li_c_top + i*li_height);
					
							}
							
							str_Cur_Batch = BlkShipEvent.term;
							str_Cur_Dock  = BlkShipEvent.dock;
							
							str = BlkShipEvent.batchno;
							if(str === null) str = "";
							  this.drawText(str, li_left + 105, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 130, li_c_top );
			   				this.context.lineTo(li_left + 130, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.ship;
							if(str === null) str = "";
							  this.drawText(str, li_left + 155, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 180, li_c_top );
			   				this.context.lineTo(li_left + 180, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.owner;
							if(str === null) str = "";
							  this.drawText(str, li_left + 220, li_c_top + i*li_height + 5, "m_fntQuayDesc", "black", "1");
			   				this.context.moveTo(li_left + 260, li_c_top );
			   				this.context.lineTo(li_left + 260, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.stype;
							if(str === null) str = "";
							  this.drawText(str, li_left + 280, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 300, li_c_top );
			   				this.context.lineTo(li_left + 300, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.wcdate;
							if(str === null) str = "";
							  this.drawText(str, li_left + 320, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 340, li_c_top );
			   				this.context.lineTo(li_left + 340, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.kldate;
							if(str === null) str = "";
							  this.drawText(str, li_left + 360, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 380, li_c_top );
			   				this.context.lineTo(li_left + 380, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.ftdate;
							if(str === null) str = "";
							  this.drawText(str, li_left + 400, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 420, li_c_top );
			   				this.context.lineTo(li_left + 420, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.lcdate;
							if(str === null) str = "";
							  this.drawText(str, li_left + 440, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 460, li_c_top );
			   				this.context.lineTo(li_left + 460, li_c_top + (i+1)*li_height);
			   				
			   				str = BlkShipEvent.dldate;
							if(str === null) str ="";
							  this.drawText(str, li_left + 480, li_c_top + i*li_height + 5, "m_fntRemark", "black", "1");
			   				this.context.moveTo(li_left + 500, li_c_top );
			   				this.context.lineTo(li_left + 500, li_c_top + (i+1)*li_height);
			   				
			   				this.context.moveTo(li_left + 80, li_c_top + (i+1)*li_height);
			   				this.context.lineTo(li_left + 500, li_c_top + (i+1)*li_height);
							
							  this.context.moveTo(li_left , li_c_top );
			   				this.context.lineTo(li_left , li_c_top + (i+1)*li_height);
			   				
			   				this.context.moveTo(li_left + 40, li_c_top );
			   				this.context.lineTo(li_left + 40, li_c_top + (i+1)*li_height);
			   				
			   				this.context.moveTo(li_left + 80, li_c_top );
			   				this.context.lineTo(li_left + 80, li_c_top + (i+1)*li_height);
							
	    				};
	    				
	    				if(li_cur_cnt > 0){
							this.drawText("Now", li_left + 20, li_c_top + (li_cur_cnt-1)*li_height/2 + 5, "m_fntRemark", "black", "1");
							
							this.context.moveTo(li_left     , li_c_top + li_cur_cnt*li_height);
              this.context.lineTo(li_left + 40, li_c_top + li_cur_cnt*li_height);
					
						}					
						if(li_next_cnt > 0){
							this.drawText("Next", li_left + 20, li_c_top + li_cur_cnt*li_height + (li_next_cnt - 1)*li_height/2 + 5, "m_fntRemark", "black", "1");
							
							this.context.moveTo(li_left     , li_c_top + (li_cur_cnt + li_next_cnt)*li_height);
              this.context.lineTo(li_left + 40, li_c_top + (li_cur_cnt + li_next_cnt)*li_height);
              
              this.context.moveTo(li_left + 40, li_c_top + (li_cur_cnt + li_next_cnt)*li_height);
              this.context.lineTo(li_left + 80, li_c_top + (li_cur_cnt + li_next_cnt)*li_height);
					
						}	    				
	    			this.context.stroke();
	    		}
	    	});
    },
    drawShip(){
      
      this.context.save();    			
    	let params = {strStartDate: this.selectedDate,      } 
      getDockArrangeList(params)
      .then(res => {  
        // console.log("drawShip...", res.list); 
        if (res.list.length > 0){	
          
          for(let i=0; i < res.list.length; i++){
            
            let p_x = [];
            let p_y = [];
            
            let q_x = [];
            let q_y = [];
            
            let q2_x = [];
            let q2_y = [];
            
            let bo_x = [];
            let bo_y = [];
            
            let dpos_x = [0, 0, 0, 0, 0];
            let dpos_y = [0, 0, 0, 0, 0];
            
            let ship = {};
              
            ship.sppno 		= res.list[i].sppno;
            ship.ship 			= res.list[i].ship;
            ship.dock 			= res.list[i].dock ;
            ship.batchno 		= parseInt(res.list[i].batchno) ;
            ship.fc 			= parseFloat(res.list[i].fc) ;
            ship.f1 			= parseFloat(res.list[i].f1) ;
            ship.f2 			= parseFloat(res.list[i].f2) ;
            ship.f3 			= parseFloat(res.list[i].f3) ;
            ship.f4 			= parseFloat(res.list[i].f4) ;
            ship.ac	 			= parseFloat(res.list[i].ac) ;
            ship.a1 			= parseFloat(res.list[i].a1) ;
            ship.a2 			= parseFloat(res.list[i].a2) ;
            ship.a3 			= parseFloat(res.list[i].a3) ;
            ship.a4 			= parseFloat(res.list[i].a4) ;
            ship.b1 			= parseFloat(res.list[i].b1) ;
            ship.sinum		= parseInt(res.list[i].sinum) ;
            ship.etc 			= res.list[i].etc ;
            ship.gracep 	= parseInt(res.list[i].gracep) ;
            ship.cutoff 	= parseInt(res.list[i].cutoff) ;
            ship.x 				= parseInt(res.list[i].x) ;
            ship.y 				= parseInt(res.list[i].y) ;
            ship.x2 			= parseInt(res.list[i].x2) ;
            ship.y2 			= parseInt(res.list[i].y2) ;
            ship.direction 		= res.list[i].direction ;
            ship.direction2 	= res.list[i].direction2 ;
            ship.shipsize 		= res.list[i].shipsize ;
            ship.skdescription = res.list[i].skdescription ;
            ship.owner 			= res.list[i].owner ;
            ship.block 			= res.list[i].block ;
            ship.breadth 		= parseFloat(res.list[i].breadth) ;
            ship.suju 			= res.list[i].suju ;
            ship.ftlength 		= parseFloat(res.list[i].ftlength );
            ship.loa 			= parseFloat(res.list[i].loa) ;
            ship.contype 		= res.list[i].contype;
            ship.batchs 		= res.list[i].batchs ;
            ship.batchf 		= res.list[i].batchf ;
            ship.batchft 		= res.list[i].batchft ;
            ship.dockmove 		= res.list[i].dockmove ;
            ship.buildorder 	= res.list[i].buildorder ;
            ship.status		 	= res.list[i].status ; 
            // ship.status		 	= parseInt(res.list[i].status) ; 

            let strsysdate	    = res.list[i].sysdate ;
              
            if(ship.status === '1' || (ship.batchs <= strSysDate && ship.batchf >= strSysDate)) {
		    						
		    						let dock_center ;
                    let ship_center ;
                    let center_check ;
                    let m_center_x, m_center_y ;
                    
                    let tmp_direction ;
									  let strDKCODE = "" ;
									
									//alert('Ship dock : ' + ship.DOCK);
									
		    						if(ship.dock === "1"||ship.dock === "A") {
										dock_center = 22.5;
										strDKCODE = "DK01" ;
									}
										
									else if(ship.dock === "2"||ship.dock === "B") {
										dock_center = 32.5;
										strDKCODE = "DK02" ;
									}
									else {
									
										strDKCODE = "DK00" ;
										dock_center = 0;
									}
									
									if(ship.status < 3)
										ship_center = ship.y + Math.ceil(ship.breadth/2) ;
									else
										ship_center = ship.y2 + Math.ceil(ship.breadth/2) ;
										
									if(ship_center >= dock_center)
										center_check = 1;
									else
										center_check = 2;
									
									let i_length      = Math.round(ship.loa + 0.5);
									let i_breadth     = Math.round(ship.breadth + 0.5);
									let bodybreadth   = Math.ceil(ship.breadth / 2);
			
									let bodylength;
									let floatinglength ;
									
									if(ship.status === '1') 
										if(ship.dock === "1"||ship.dock === "A")
											bodylength = ship.loa - ship.fc - ship.ac;
										else
											bodylength = ship.loa - ship.fc - ship.ac - 5;
										
									else if(ship.status === '2'){
										bodylength = ship.ftlength - ship.ac;
										floatinglength = ship.ftlength - ship.ac;
									}
									else if(ship.status === '3'){
										bodylength = ship.loa - ship.fc - ship.ac ;
										floatinglength = ship.ftlength - ship.ac;
									}
									
									let midpos ;
									let headgab = Math.ceil(ship.fc / 5) ;
									let tailgab = Math.ceil(ship.ac / 5) ;
									let f1      = Math.ceil(ship.f1 / 2) ;
									let f2      = Math.ceil(ship.f2 / 2) ;
									let f3      = Math.ceil(ship.f3 / 2) ;
									let f4      = Math.ceil(ship.f4 / 2) ;
									let a1      = Math.ceil(ship.a1 / 2) ;
									let a2      = Math.ceil(ship.a2 / 2) ;
									let a3      = Math.ceil(ship.a3 / 2) ;
									let a4      = Math.ceil(ship.a4 / 2) ;
									let b1      = Math.ceil(ship.b1 / 2) ;
									let m_horpos_x = 10;
									let m_horpos_y = 10;
									let m_verpos_x = 10;
									let m_verpos_y = 10;
								
									
									if(ship.status < '3'){
										m_center_x = ship.x ;
										m_center_y = ship.y + Math.ceil(ship.breadth / 2);
									}
									else{
									
										m_center_x = ship.x2;
										m_center_y = ship.y2 + Math.ceil(ship.breadth / 2);
										
									} ;
									
									this.context.strokeStyle = "rgb(23,36,94)" ;
									this.context.lineWidth = 2.0;
				
									if(ship.status < '3')
										tmp_direction = ship.direction;
									else
										tmp_direction = ship.direction2;
										
									if(tmp_direction === "L"){
										if(ship.status === '1' || ship.status === '4'){
										
											if(ship.suju === "O")	
												this.context.fillStyle = "rgb(147,181,236)" ;
											else
												this.context.fillStyle = "rgb(0,255,0)" ;
												
											//DRAW SHIP IN DOCK
											
											if(headgab != 0 && tailgab != 0){
												
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												//alert(strDKCODE + "/Y0= " +  DockObjList.getDKItem(strDKCODE, "DK_TOP") + "/mcenter_y = " + m_center_y) ;
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[10]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[10]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[11]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[11]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[12]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[12]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + headgab * 5;
												
												q_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q2_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
												
												q2_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q2_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q2_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q2_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q2_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q2_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q2_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q2_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q2_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q2_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
													
												this.context.beginPath();
												this.context.moveTo(p_x[0], p_y[0]) ;
                        this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]); 
                        this.context.lineTo(p_x[0], p_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
						
												m_horpos_x = p_x[6] ;
												m_horpos_y = q_x[5] ;
												m_verpos_x = p_y[0] ;
												m_verpos_y = p_y[12];
											}	
											else if(headgab === 0 && tailgab != 0){
													
												bo_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin ;
												bo_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1] = bo_x[0] ; 
												bo_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin ;
												q_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab) + this.prt_margin ;
												q_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 2) + this.prt_margin ;
												q_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 3) + this.prt_margin ;
												q_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 4) + this.prt_margin ;
												q_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 5) + this.prt_margin ;
												q_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 5) + this.prt_margin ;
												q2_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
												
												q2_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 4) + this.prt_margin ;
												q2_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q2_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 3) + this.prt_margin ;
												q2_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q2_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 2) + this.prt_margin ;
												q2_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q2_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab) + this.prt_margin ;
												q2_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q2_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin ;
												q2_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(q_x[0], q_y[0]) ;
												this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
								
												m_horpos_x = bo_x[0];
												m_horpos_y = q_x[5];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											else if(headgab != 0 && tailgab === 0){
											
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[10]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[10]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[11]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[11]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[12]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[12]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[1]        = bo_x[0] ;
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
													
												this.context.beginPath();
												this.context.moveTo(p_x[0], p_y[0]) ;
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
                        this.context.lineTo(p_x[0], p_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
																								
												m_horpos_x = p_x[6];
												m_horpos_y = bo_x[0];
												m_verpos_x = bo_y[1];
												m_verpos_y = bo_y[0];
												
											}
											else if(headgab === 0 && tailgab === 0){
											
												bo_x[0]	= this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1] = bo_x[0];
												bo_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												bo_y[2] = bo_y[1] ;
												
												bo_x[3] = bo_x[2];
												bo_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(bo_x[2], bo_y[2]) ;
												this.context.lineTo(bo_x[3], bo_y[3]) ;
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
										}
										else if(ship.status === '2'){
											if(tailgab != 0){
												
												bo_x[0]	= this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]	= bo_x[0] ;
												bo_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin ;
												q_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab) + this.prt_margin ;
												q_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 2) + this.prt_margin ;
												q_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 3) + this.prt_margin ;
												q_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 4) + this.prt_margin ;
												q_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 5) + this.prt_margin ;
												q_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
											
												q2_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 5) + this.prt_margin ;
												q2_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
												
												q2_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 4) + this.prt_margin ;
												q2_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q2_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 3) + this.prt_margin ;
												q2_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q2_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab * 2) + this.prt_margin ;
												q2_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q2_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + tailgab) + this.prt_margin ;
												q2_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q2_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin ;
												q2_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
								
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(q_x[0], q_y[0]) ;
												this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
								
												m_horpos_x = bo_x[0];
												m_horpos_y = q_x[5];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											else{
												
												bo_x[0]	= this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1] = bo_x[0];
												bo_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + floatinglength) + this.prt_margin;
												bo_y[2] = bo_y[1] ;
												
												bo_x[3] = bo_x[2];
												bo_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(bo_x[2], bo_y[2]) ;
												this.context.lineTo(bo_x[3], bo_y[3]) ;
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
										}
								
										if(ship.status === '3'){
										
											if(headgab != 0 && tailgab != 0){
												
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[10]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[10]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[11]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[11]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[12]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[12]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + headgab * 5;
												
												dpos_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.fillStyle = "rgb(200,200,210)" ;
												this.context.beginPath();
												this.context.moveTo(p_x[0], p_y[0]) ;
                        this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(dpos_x[0], dpos_y[0]) ;
                        this.context.lineTo(dpos_x[1], dpos_y[1]) ;
                        this.context.lineTo(p_x[1], p_y[0]) ;
                        this.context.stroke();
												this.context.fill();
												//this.context.closePath() ;
												
												dpos_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q2_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
												
												q2_x[1]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q2_y[1]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q2_x[2]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q2_y[2]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q2_x[3]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q2_y[3]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q2_x[4]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q2_y[4]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q2_x[5]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q2_y[5]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3] = dpos_x[2] ;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[4] = dpos_x[3] ;
												dpos_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												
												if(ship.suju === "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ;
												
												this.context.beginPath();
                        this.context.moveTo(dpos_x[2], dpos_y[2]) ;
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(dpos_x[3], dpos_y[3]) ;
                        this.context.lineTo(dpos_x[4], dpos_y[4]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = p_x[6];
												m_horpos_y = q_x[5];
												m_verpos_x = p_y[0];
												m_verpos_y = p_y[12];

											}
											////////////////////////////////////////
											else if(headgab === 0 && tailgab != 0){
											
												bo_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin ;
												bo_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]  = bo_x[0];
												bo_y[1]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
								
												dpos_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.fillStyle = "rgb(200,200,210)" ;
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]);
												this.context.lineTo(bo_x[1], bo_y[1]);
												this.context.lineTo(dpos_x[0], dpos_y[0]);
												this.context.lineTo(dpos_x[1], dpos_y[1]);
												this.context.lineTo(bo_x[0], bo_y[0]);
												//this.context.stroke() ;
												this.context.fill();
												//this.context.closePath();
												
												dpos_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												q_x[1] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q_x[4] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q_x[5] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q_y[5] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 5) + this.prt_margin;
												q2_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
												
												q2_x[1]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 4) + this.prt_margin;
												q2_y[1]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q2_x[2]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 3) + this.prt_margin;
												q2_y[2]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q2_x[3]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab * 2) + this.prt_margin;
												q2_y[3]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q2_x[4]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength + tailgab) + this.prt_margin;
												q2_y[4]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q2_x[5]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												q2_y[5]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3] = dpos_x[2] ;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[4] = dpos_x[3] ;
												dpos_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												if(ship.suju === "O")	
													//this.context.fillStyle = "rgb(200,200,210)" ;
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ;
													
												this.context.beginPath();
                        this.context.moveTo(dpos_x[2], dpos_y[2]) ;
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(dpos_x[3], dpos_y[3]) ;
                        this.context.lineTo(dpos_x[4], dpos_y[4]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos.x = bo_x[0];
												m_horpos.y = q_x[5];
												m_verpos.x = bo_y[0];
												m_verpos.y = bo_y[1];
								
											}
											else if(headgab != 0 && tailgab === 0){
												
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 2) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[10]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 3) + this.prt_margin;
												p_y[10]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[11]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 4) + this.prt_margin;
												p_y[11]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[12]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5) + this.prt_margin;
												p_y[12]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + headgab * 5;
												
												dpos_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.fillStyle = "rgb(200,200,210)" ;
												this.context.beginPath();
												this.context.moveTo(p_x[0], p_y[0]) ;
                        this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(dpos_x[0], dpos_y[0]) ;
                        this.context.lineTo(dpos_x[1], dpos_y[1]) ;
                        this.context.lineTo(p_x[1], p_y[0]) ;
                        this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												dpos_x[2] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[2] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength) + this.prt_margin ;
												bo_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[1]  = bo_x[0];
												bo_y[1]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3] = dpos_x[2] ;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[4] = dpos_x[3] ;
												dpos_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												if(ship.suju === "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ;
													
												this.context.beginPath();
												this.context.moveTo(dpos_x[2], dpos_x[2]) ;
												this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(dpos_x[3], dpos_x[3]) ;
												this.context.lineTo(dpos_x[4], dpos_x[4]) ;
												this.context.lineTo(dpos_x[2], dpos_x[2]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = p_x[6];
												m_horpos_y = bo_x[0];
												m_verpos_x = bo_y[1];
												m_verpos_y = bo_y[0];
												
											}
											else if(headgab === 0 && tailgab === 0){
											
												bo_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin ;
												bo_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]  = bo_x[0];
												bo_y[1]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(dpos_x[0], dpos_x[0]) ;
												this.context.lineTo(dpos_x[1], dpos_x[1]) ;
												this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												dpos_x[2]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[2]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[2]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												bo_y[2]  = bo_y[1];
												
												bo_x[3]  = bo_x[2] ;
												bo_y[3]  = Cal_V_In_Dock(m_rdock[dock], m_center_y - bodybreadth);
												
												bo[3].x  = bo[2].x;
												bo[3].y  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3] = dpos_x[2] ;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(dpos_x[2], dpos_x[2]) ;
												this.context.lineTo(bo_x[2], bo_y[2]) ;
												this.context.lineTo(bo_x[3], bo_y[3]) ;
												this.context.lineTo(dpos_x[3], dpos_x[3]) ;
												this.context.lineTo(dpos_x[2], dpos_x[2]) ;
												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											if(ship.status === '3'){
											
												dpos_x[0] = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												this.context.moveTo(dpos_x[0], dpos_x[0]) ;
												this.context.lineTo(dpos_x[1], dpos_x[1]) ;
												
											}
										}
									}
									else if(tmp_direction === "R"){
										//alert(tmp_direction) ;
										if(ship.suju === "O")	
											this.context.fillStyle = "rgb(147,181,236)" ;
										else
											this.context.fillStyle = "rgb(0,255,0)" ;
										
										if(ship.status === '1' || ship.status === '4'){
											
											if(tailgab != 0 && headgab != 0){
												
												q_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												q_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
									
												q_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);											
												
												q_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
													
												q_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
														
												q2_x[0]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q2_y[0]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
											
												q2_x[1]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q2_y[1]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q2_x[2]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q2_y[2]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q2_x[3]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q2_y[3]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
								
												q2_x[4]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q2_y[4]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
															
												q2_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q2_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + tailgab * 5;
							
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 2) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 3) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 4) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 4) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 3) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[10]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 2) + this.prt_margin;
												p_y[10]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[11]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab) + this.prt_margin;
												p_y[11]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[12]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength) + this.prt_margin;
												p_y[12]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												
												this.context.beginPath();

												this.context.moveTo(p_x[0], p_y[0]) ; 
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
												this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
												this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
												this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
												this.context.lineTo(q_x[0], q_y[0]) ;
												
												this.context.moveTo(q_x[0], q_y[0]) ;
												this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
												this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);												

												this.context.lineTo(q2_x[0], q2_y[0]) ;
												this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
												this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
												this.context.lineTo(p_x[0], p_y[0]) ;

												this.context.stroke();
												this.context.fill();
												//this.context.closePath();
												
												m_horpos_x = q_x[5];
												m_horpos_y = p_x[6];
												m_verpos_x = q_y[0];
												m_verpos_y = q2_y[5];
								
											}
											else if(tailgab === 0 && headgab != 0){
											
												bo_x[0]   	   = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
											
												p_x[0]	       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												p_y[0]  	   = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
											
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 2) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 3) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 4) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 4) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 3) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[10]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 2) + this.prt_margin;
												p_y[10]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[11]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab) + this.prt_margin;
												p_y[11]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[12]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												p_y[12]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(p_x[0], p_y[0]) ;
                        this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
                        this.context.stroke();
                        //this.context.fill();
                        this.context.closePath();
						    					
												m_horpos_x = bo_x[0];
												m_horpos_y = p_x[6];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											else if(tailgab != 0 && headgab === 0){
											
												q_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												q_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
														
												q2_x[0]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q2_y[0]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q2_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q2_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q2_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q2_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q2_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q2_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q2_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
															
												q2_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q2_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + tailgab * 5;
								
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
                        this.context.moveTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
                        this.context.lineTo(bo_x[1], bo_y[1]) ;
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.stroke();
                        //this.context.fill();
                        this.context.closePath();
						    				
												m_horpos_x = q_x[5];
												m_horpos_y = bo_x[0];
												m_verpos_x = q_y[0];
												m_verpos_y = bo_y[0];
								
											}
											else if(tailgab === 0 && headgab === 0){
												
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												bo_y[2]        = bo_y[1];
												
												bo_x[3]        = bo_x[2];
												bo_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
												this.context.moveTo(bo[0]);
												this.context.lineTo(bo[1]);
												this.context.lineTo(bo[2]);
												this.context.lineTo(bo[3]);
												this.context.lineTo(bo[0]);
												this.context.stroke();
                        //this.context.fill();
                        this.context.closePath();
								
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
										}
										else if(ship.status === '2'){
											if(tailgab != 0){
											
												q_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												q_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q_y[1]		  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
											
												q_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
														
												q2_x[0]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q2_y[0]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[1]       = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q2_y[1]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q2_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q2_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q2_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q2_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
								
												q2_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q2_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
															
												q2_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q2_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos         = m_center_x + tailgab * 5;
								
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												this.context.beginPath();
                        this.context.moveTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
                        this.context.lineTo(bo_x[1], bo_y[1]) ;
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.stroke();
                        //this.context.fill();
                        this.context.closePath();
								
												m_horpos_x = q_x[5];
												m_horpos_y = bo_x[0];
												m_verpos_x = q_y[0];
												m_verpos_y = bo_y[0];
												
											}
											else{
												
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
																
												bo_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + floatinglength) + this.prt_margin;
												bo_y[2]        = bo_y[1];
												
												bo_x[3]        = bo_x[2];
												bo_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												
												this.context.beginPath();
												this.context.moveTo(bo[0]);
												this.context.lineTo(bo[1]);
												this.context.lineTo(bo[2]);
												this.context.lineTo(bo[3]);
												this.context.lineTo(bo[0]);
												this.context.stroke();
                        //this.context.fill();
                        this.context.closePath();
								
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
								
											}
										}
								
										if(ship.status === '3'){
											if(tailgab != 0 && headgab != 0){
											
												q_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												q_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
														
												q2_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q2_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q2_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q2_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q2_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q2_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q2_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q2_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q2_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
												
												q2_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q2_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
							
												midpos         = m_center_x + tailgab * 5;
												
												/*this.context.beginPath();
						    					this.context.moveTo(q_x[0], q_y[0]) ;
						    					this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
						    					this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
						    					this.context.lineTo(q2_x[0], q2_y[0]) ;
						    					this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
						    					this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
						    					this.context.lineTo(q_x[0], q_y[0]) ;
						    					this.context.stroke();
						    					this.context.fill();
						    					this.context.closePath(); *///checked
						    					
												this.context.fillStyle = "rgb(200,200,210)" ;
												
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
												
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 2) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 3) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 4) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 5) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 4) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 3) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[10]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab * 2) + this.prt_margin;
												p_y[10]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[11]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength + headgab) + this.prt_margin;
												p_y[11]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[12]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + bodylength) + this.prt_margin;
												p_y[12]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(p_x[0], p_y[0]) ;
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(p_x[0], p_y[0]) ;
                        this.context.stroke();
                        this.context.fill();
                        this.context.closePath();
											
												if(ship.SUJU == "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ; *///checked
													
												dpos_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1]	  = dpos_x[0] ;
												dpos_y[1]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath();
												this.context.moveTo(q_x[0], q_y[0]) ;
												this.context.lineTo(q2_x[5], q2_y[5]) ;
												this.context.lineTo(dpos_x[0], dpos_y[0]);
												this.context.lineTo(dpos_x[1], dpos_y[1]);
												this.context.lineTo(q_x[0], q_y[0]);
												this.context.stroke();
                        this.context.fill();
                        this.context.closePath(); *///checked
												
												this.context.fillStyle = "rgb(200,200,210)" ;
								
												dpos_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[3]  = dpos_x[2] ;
												dpos_y[3]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[4] = dpos_x[3] ;
												dpos_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												/*this.context.beginPath();
												this.context.moveTo(dpos_x[2], dpos_y[2]) ;
												this.context.lineTo(p_x[0], p_y[0]);
												this.context.lineTo(p_x[12], p_y[12]);
												this.context.moveTo(dpos_x[3], dpos_y[3]) ;
												this.context.moveTo(dpos_x[4], dpos_y[4]) ;
												this.context.stroke();
						    					this.context.fill();
						    					this.context.closePath();*///checked 
												
												//Draw outline
												this.context.moveTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(p_x[0], p_y[0]) ;
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.stroke();
                        this.context.closePath(); 
						    			
												m_horpos_x = q_x[5];
												m_horpos_y = p_x[6];
												m_verpos_x = q_y[0];
												m_verpos_y = q2_y[5];
								
											}
											else if(tailgab === 0 && headgab != 0){
												
												this.context.fillStyle = "rgb(200,200,210)" ;
											
												p_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												p_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
								
												p_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab) + this.prt_margin;
												p_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f4);
											
												p_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 2) + this.prt_margin;
												p_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f3);
												
												p_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 3) + this.prt_margin;
												p_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f2);
												
												p_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 4) + this.prt_margin;
												p_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + f1);
												
												p_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + 7.0);
												
												p_x[6]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[6]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y);
												
												p_x[7]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 5) + this.prt_margin;
												p_y[7]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - 7.0);
												
												p_x[8]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 4) + this.prt_margin;
												p_y[8]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f1);
												
												p_x[9]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 3) + this.prt_margin;
												p_y[9]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f2);
												
												p_x[10]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab * 2) + this.prt_margin;
												p_y[10]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f3);
												
												p_x[11]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength + headgab) + this.prt_margin;
												p_y[11]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - f4);
												
												p_x[12]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												p_y[12]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(p_x[0], p_y[0]) ;
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.lineTo(p_x[0], p_y[0]) ;
                        this.context.stroke();
                        this.context.fill();
                        this.context.closePath();
						    					
												if(ship.SUJU == "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ; *///checked
												
												
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
											
												bo_x[1]       = bo_x[0];
												bo_y[1]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[0]     = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[0]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1]	  = dpos_x[0];
												dpos_y[1]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
											
												/*this.context.beginPath() ;
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(dpos_x[0], dpos_y[0]) ;
												this.context.lineTo(dpos_x[1], dpos_y[1]) ;
                        this.context.stroke();
                        this.context.fill();
                        this.context.closePath(); */
								
												this.context.fillStyle = "rgb(200,200,210)" ;
												
												dpos_x[2]     = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[2]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[3] = dpos_x[2] ;
												dpos_y[3] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
											
												dpos_x[4] = dpos_x[3] ;
												dpos_y[4] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(dpos_x[2], dpos_y[2]) ;
												this.context.lineTo(p_x[0], p_y[0]) ;
												this.context.lineTo(p_x[12], p_y[12]) ;
												this.context.lineTo(dpos_x[3], dpos_y[3]) ;
												this.context.lineTo(dpos_x[4], dpos_y[4]) ;
												this.context.moveTo(dpos_x[2], dpos_y[2]) ;
                        this.context.stroke();
                        this.context.closePath();
                        this.context.fill(); */
						    					
												//Drawing OutLine
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(p_x[0], p_y[0]) ;
												this.context.bezierCurveTo(p_x[1], p_y[1], p_x[2], p_y[2], p_x[3], p_y[3]);
                        this.context.bezierCurveTo(p_x[4], p_y[4], p_x[5], p_y[5], p_x[6], p_y[6]);
                        this.context.bezierCurveTo(p_x[7], p_y[7], p_x[8], p_y[8], p_x[9], p_y[9]);
                        this.context.bezierCurveTo(p_x[10], p_y[10], p_x[11], p_y[11], p_x[12], p_y[12]);
                        this.context.moveTo(bo_x[0], bo_y[0]) ;
                        this.context.stroke();
                        this.context.closePath();
								
												m_horpos_x = bo_x[0];
												m_horpos_y = p_x[6];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											else if(tailgab != 0 && headgab === 0){
												
												if(ship.suju === "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ;
													
												q_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												q_x[1]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q_y[1]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a4);
												
												q_x[2]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q_y[2]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a3);
												
												q_x[3]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q_y[3]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a2);
												
												q_x[4]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q_y[4]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - a1);
												
												q_x[5]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q_y[5]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - b1);
													
												q2_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												q2_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + b1);
												
												q2_x[1]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab) + this.prt_margin;
												q2_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a1);
												
												q2_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 2) + this.prt_margin;
												q2_y[2]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a2);
												
												q2_x[3]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 3) + this.prt_margin;
												q2_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a3);
												
												q2_x[4]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 4) + this.prt_margin;
												q2_y[4]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + a4);
															
												q2_x[5]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5) + this.prt_margin;
												q2_y[5]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												midpos = m_center_x + tailgab * 5;
								
												dpos_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1] = dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(dpos_x[0], dpos_y[0]) ;
												this.context.lineTo(dpos_x[1], dpos_y[1]) ;
												this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.stroke();
                        this.context.closePath();
                        this.context.fill(); */
												
												this.context.fillStyle = "rgb(200,200,210)" ;
												
												dpos_x[2]      = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[2]      = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[0]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), midpos + bodylength) + this.prt_margin;
												bo_y[0]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												bo_x[1]       = bo_x[0];
												bo_y[1]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3]     = dpos_x[2];
												dpos_y[3]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
											
												dpos_x[4]     = dpos_x[3];
												dpos_y[4]     = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(dpos_x[2], dpos_y[2]) ;
												this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(dpos_x[3], dpos_y[3]) ;
												this.context.lineTo(dpos_x[4], dpos_y[4]) ;
												this.context.stroke();
                        this.context.closePath();
                        this.context.fill();  */
												
												//Draw Ship Outline;	
												this.context.moveTo(q_x[0], q_y[0]) ;
                        this.context.bezierCurveTo(q_x[1], q_y[1], q_x[2], q_y[2], q_x[3], q_y[3]);
                        this.context.quadraticCurveTo(q_x[4], q_y[4], q_x[5], q_y[5]);
                        this.context.lineTo(q2_x[0], q2_y[0]) ;
                        this.context.bezierCurveTo(q2_x[1], q2_y[1], q2_x[2], q2_y[2], q2_x[3], q2_y[3]);
                        this.context.quadraticCurveTo(q2_x[4], q2_y[4], q2_x[5], q2_y[5]);
                        this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(q_x[0], q_y[0]) ;
                        this.context.stroke();
                        this.context.closePath();
								
												m_horpos_x = q_x[5];
												m_horpos_y = bo_x[0];
												m_verpos_x = q_y[0];
												m_verpos_y = bo_y[0];
								
											}
											else if(tailgab === 0 && headgab === 0){
												if(ship.suju === "O")	
													this.context.fillStyle = "rgb(147,181,236)" ;
												else
													this.context.fillStyle = "rgb(0,255,0)" ;
											
												bo_x[0]    = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x) + this.prt_margin;
												bo_y[0]    = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
								
												bo_x[1]        = bo_x[0];
												bo_y[1]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[0]         = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[0]         = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												dpos_x[1]		= dpos_x[0] ;
												dpos_y[1]       = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(dpos_x[0], dpos_y[0]) ;
												this.context.lineTo(dpos_x[1], dpos_y[1]) ;
												this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
                        this.context.closePath();
                        this.context.fill(); */
											
												dpos_x[2]      = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + headgab * 5 + bodylength - floatinglength) + this.prt_margin;
												dpos_y[2]      = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
																
												bo_x[2]        = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + bodylength) + this.prt_margin;
												bo_y[2]        = bo_y[1];
												
												bo_x[3]        = bo_x[2];
												bo_y[3]        = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[3]	 	= dpos_x[2] ;
												dpos_y[3]		= this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[4]		= dpos_x[3] ;
												dpos_y[4]   	= this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												/*this.context.beginPath() ;
												this.context.moveTo(dpos_x[2], dpos_y[2]) ;
												this.context.lineTo(bo_x[2], bo_y[2]) ;
												this.context.lineTo(bo_x[3], bo_y[3]) ;
												this.context.lineTo(dpos_x[3], dpos_y[3]) ;
												this.context.lineTo(dpos_x[4], dpos_y[4]) ;
												this.context.stroke();
                        this.context.closePath();
                        this.context.fill(); */
												
												//Draw ship Outline ;
												this.context.moveTo(bo_x[0], bo_y[0]) ;
												this.context.lineTo(bo_x[1], bo_y[1]) ;
												this.context.lineTo(bo_x[2], bo_y[2]) ;
												this.context.lineTo(bo_x[3], bo_y[3]) ;
												this.context.lineTo(bo_x[0], bo_y[0]) ;
												this.context.stroke();
												this.context.closePath();
												
												m_horpos_x = bo_x[0];
												m_horpos_y = bo_x[2];
												m_verpos_x = bo_y[0];
												m_verpos_y = bo_y[1];
												
											}
											if(ship.status === '3'){
											
												dpos_x[0]  = this.CalcHorInDock(this.getDKItem(strDKCODE, "DK_LEFT"), m_center_x + tailgab * 5 + floatinglength) + this.prt_margin;
												dpos_y[0]  = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y - bodybreadth);
												
												dpos_x[1] =	dpos_x[0] ;
												dpos_y[1] = this.CalcVerInDock(this.getDKItem(strDKCODE, "DK_TOP"), m_center_y + bodybreadth);
												
												this.context.moveTo(dpos_x[0], dpos_y[0]) ;
												this.context.lineTo(dpos_x[1], dpos_y[1]) ;
												
											} 
										}
									} 
									
		    					} // end if ship.STATUS == 1
            
          } // End for loop i
            
        } // end if rtn.chk
      }) ;	    		
      this.context.restore();	    		
    },// drawShip() end 	
    //Cần bổ sung thêm tìm kiếm Block tại đây=> Khi thấy block thì thiết lập màu để dễ  thấy hơn
    drawBlk() {
      // console.log("drawBlk...", this.shipNo); 
      let str3;     
      let strShip = this.shipNo;
      let strBlk = this.block;//null
      let loc_dis_y = [] ;
      let dashPat = [10, 10] ;
      
      const statusMapping = {
          '1': "Panel for Assembly",
          '2': "Assy Block shift out",
          '3': "Assy Block shop out",
          '4': "Assy Block turn over",
          '5': "Block PE",
          '6': "Block Pre-Outfitting",
          '7': "Block Grit Blasting",
          '8': "Block Coating",
          '9': "Block Insulation",
          'A': "Block 2nd PE",
          'B': "Standby for Erection",
          'C': "Erection",
          'D': "Raining Condition",
          'E': "Make Free Space"
      };

      this.objects = []; 

      for (let i = 0 ; i < 100 ; i++) {
        loc_dis_y[i] = "N" ;
      };    
      
      for(let ll_i=0; ll_i<this.Blk_Cnt; ll_i++){  

        let	strLOC 			    = this.BlkObjList[ll_i].loc ;
        let	strSHIP_NO 		  = this.BlkObjList[ll_i].shipno ;
        let	strBLOCK 		    = this.BlkObjList[ll_i].block ;
        let	strBLOCK_DESC   = this.BlkObjList[ll_i].blockdesc ;
        let	strPE_BLK 		  = this.BlkObjList[ll_i].peblk ;
        let	strTOVER 		    = this.BlkObjList[ll_i].tover ;
        let	strPE 			    = this.BlkObjList[ll_i].pe ;
        let	intDIS_ORDER 	  = this.BlkObjList[ll_i].disorder ;
        let	strADD_LOC 		  = this.BlkObjList[ll_i].addloc ;
        let	strERECT_BLK 	  = this.BlkObjList[ll_i].erectblk ;
        let	strSTATUS 		  = this.BlkObjList[ll_i].status ;
        let	intSIZE_L 		  = this.BlkObjList[ll_i].sizel ;
        let	intSIZE_B		    = this.BlkObjList[ll_i].sizeb ;
        let	intSIZE_D 		  = this.BlkObjList[ll_i].sized ;
        let	intWEIGHT 		  = this.BlkObjList[ll_i].weight ;
        let	intPOSX 		    = this.BlkObjList[ll_i].posx ;
        let	intPOSY 		    = this.BlkObjList[ll_i].posy ;
        let	strROTATION 	  = this.BlkObjList[ll_i].rotation ;
        let	strJUYA 		    = this.BlkObjList[ll_i].juya ;
        let	strDIS_LOC 		  = this.BlkObjList[ll_i].disloc ;
        let	intL1 			    = this.BlkObjList[ll_i].l1 ;
        let	intL2 			    = this.BlkObjList[ll_i].l2 ;
        let	intTM 			    = this.BlkObjList[ll_i].tm ;
        let	strAFTER_PNT 	  = this.BlkObjList[ll_i].afterpnt ;
        let	strEDT 			    = this.BlkObjList[ll_i].edt ;
        let	strARRANGE 		  = this.BlkObjList[ll_i].arrange ;
        let	strPRE_STATUS   = this.BlkObjList[ll_i].prestatus ;
        let	strACT_ERCDT   	= this.BlkObjList[ll_i].actercdt ;
        let	intCOLOR_R 		  = this.BlkObjList[ll_i].colorr ;
        let	intCOLOR_G 		  = this.BlkObjList[ll_i].colorg ;
        let	intCOLOR_B 		  = this.BlkObjList[ll_i].colorb ; 
        let intV_FILL		    = this.BlkObjList[ll_i].vfill ; 
        let	strVSBL_STATUS 	= this.BlkObjList[ll_i].vsblstatus ;
			    	
        let	intX_01 		= (this.BlkObjList[ll_i].blkx01 * this.zoom) / 100 + this.prt_margin; 
        let	intY_01 		= (this.BlkObjList[ll_i].blky01 * this.zoom) / 100 ;
        let	intX_02 		= (this.BlkObjList[ll_i].blkx02 * this.zoom) / 100 + this.prt_margin;
        let	intY_02 		= (this.BlkObjList[ll_i].blky02 * this.zoom) / 100;
        let	intX_03 		= (this.BlkObjList[ll_i].blkx03 * this.zoom) / 100 + this.prt_margin;
        let	intY_03 		= (this.BlkObjList[ll_i].blky03 * this.zoom) / 100;
        let	intX_04 		= (this.BlkObjList[ll_i].blkx04 * this.zoom) / 100 + this.prt_margin;
        let	intY_04 		= (this.BlkObjList[ll_i].blky04 * this.zoom) / 100;					
					
        if(strVSBL_STATUS === "0") continue;

        if(strARRANGE === "T-5" || strARRANGE === "T-7" || strARRANGE === "T-9" || strARRANGE === "T-10") continue;
							  
        if(intV_FILL === 0){
          this.context.fillStyle = "rgb(" + intCOLOR_R + "," +  intCOLOR_G + ", "  + intCOLOR_B + ")" ;
        } ;
        
        if(intV_FILL === 1) {
          this.context.fillStyle = "rgb(50, 255, 50)" ;
        } ;
        
        if(intV_FILL === 2) {
          this.context.fillStyle = "rgb(139,5,26)" ;
        }
				
        this.context.beginPath();
        this.context.moveTo(intX_01, intY_01) ;
        this.context.lineTo(intX_02, intY_02) ;
        this.context.lineTo(intX_03, intY_03) ;
        this.context.lineTo(intX_04, intY_04) ;
        this.context.lineTo(intX_01, intY_01 - 4) ;// add - 4
        //Add more
        // if(Ship != '' && Block != '' && strSHIP_NO == Ship && (strBLOCK == Block || strPE_BLK == Block|| strERECT_BLK == Block)){
        //   //alert(chk);
        //   this.context.strokeStyle = '#F01818';
        //   this.context.lineWidth = 8;
        // }                                    
        // else 
        // console.log('ShipNo: ', strSHIP_NO);
        // console.log('Block: ', strBLOCK);
        if(strSHIP_NO === strShip && (strBLOCK === strBlk || strBLOCK.substr(0,1) === strBlk || strBLOCK.substr(0,2) === strBlk || strBLOCK.substr(0,3) === strBlk )){
          this.context.strokeStyle = '#F01818';
          this.context.lineWidth = 8;
        }
        else if(strSHIP_NO === strShip && (strPE_BLK === strBlk || strPE_BLK.substr(0,1) === strBlk || strPE_BLK.substr(0,2) === strBlk || strPE_BLK.substr(0,3) === strBlk )){
          this.context.strokeStyle = '#F01818';
          this.context.lineWidth = 8;
        }
        else if(strSHIP_NO === strShip && strERECT_BLK === strBlk ){
          this.context.strokeStyle = '#F01818';
          this.context.lineWidth = 8;
        }
        else if(strSHIP_NO === strShip && strBlk.length === 0){
          this.context.strokeStyle = '#F01818';
          this.context.lineWidth = 8;
        }
        else if((strBLOCK === strBlk || strPE_BLK === strBlk || strBLOCK.substr(0,1) === strBlk || strPE_BLK.substr(0,1) === strBlk || strBLOCK.substr(0,2) === strBlk || strPE_BLK.substr(0,2) === strBlk || strBLOCK.substr(0,3) === strBlk || strPE_BLK.substr(0,3) === strBlk) && strShip.length === 0){
          this.context.strokeStyle = '#F01818';
          this.context.lineWidth = 8;
        }
        else{
          this.context.strokeStyle = '#C0C0C0';
          this.context.lineWidth = 1;          
        }
        this.context.stroke();
        this.context.fill();
						
        let str_ship, str_blk ;
        
        if(strBLOCK.length < 5) 
          str_blk = strBLOCK;          
        else if (strBLOCK.length > 4 && intL1 < intL2) 
          str_blk =  strPE_BLK ;          
        else if (strSTATUS === "5") 
          str_blk =  strPE_BLK ;            
        else if (strSTATUS === "B" && strPRE_STATUS < "A")
          str_blk =  strPE_BLK ;          
        else if (strSTATUS === "C" || (strSTATUS === "B" && strPRE_STATUS > "9" ))
          str_blk =  strERECT_BLK ;          
        else if(strSTATUS === "D" || strSTATUS === "E") {
          if(strPRE_STATUS === "5")
            str_blk =  strPE_BLK ;		
          else if(strPRE_STATUS === "C" || strPRE_STATUS === "B")
            str_blk =  strERECT_BLK ;	
          else
            str_blk =  strPE_BLK ;
        }
        else
          str_blk =  strPE_BLK ;        
      
        if(str_blk === "XXXX")
          str_blk = strBLOCK;  

        str_ship = strSHIP_NO.substr(0,4) ;        
        this.drawText(str_ship, intX_01 + 2,  intY_01 + 1, "m_fntshipdesc", "black", "0");
        this.drawText(str_blk, intX_01 + 2,  intY_01 + 11, "m_fntshipdesc", "black", "0");
        
        str3 = statusMapping[strSTATUS] || " ";

        this.objects.push({shipno: str_ship, 
                            block: strBLOCK_DESC,
                            peblk: strPE_BLK,
                            erectblk: strERECT_BLK,
                            edt: strEDT,                                                             
                            actercdt: strACT_ERCDT,
                            weight: intWEIGHT,
                            disloc: strDIS_LOC,
                            status: str3,
                            x: intX_01, 
                            y: intY_01, 
                            width: intX_02 - intX_01, 
                            height: intY_04 - intY_01}) //intX_01, intY_01, 100, 100
            
      } // End for loop
      //  console.log(this.objects);   
      this.context.restore() ;
            	
    }, //drawBlk() end
    //OK
    async LoadYardObjList() {
      let params = { strStartDate: this.selectedDate };

      try {
          let res = await getYardObj(params); // Đợi API hoàn thành

          if (res.list.length > 0) {
              this.YardObj_Cnt = res.list.length;
              this.resetYardList();
              this.resetDockList();

              for (let i = 0; i < res.list.length; i++) {
                  let strACODE = res.list[i].acode;
                  let strBATCH = res.list[i].batch;
                  let intCOLOR_R = parseInt(res.list[i].colorr);
                  let intCOLOR_G = parseInt(res.list[i].colorg);
                  let intCOLOR_B = parseInt(res.list[i].colorb);
                  let intGON = parseInt(res.list[i].gon);
                  let strDESCRIPT = res.list[i].descript;
                  let strPOS_DIV = res.list[i].posdiv;
                  let strSTATUS = res.list[i].status;
                  let intTEXT_COLOR_R = parseInt(res.list[i].textcolorr);
                  let intTEXT_COLOR_G = parseInt(res.list[i].textcolorg);
                  let intTEXT_COLOR_B = parseInt(res.list[i].textcolorb);
                  let intLINE_COLOR_R = parseInt(res.list[i].linecolorr);
                  let intLINE_COLOR_G = parseInt(res.list[i].linecolorg);
                  let intLINE_COLOR_B = parseInt(res.list[i].linecolorb);
                  let intX_01 = parseInt(res.list[i].posx01);
                  let intY_01 = parseInt(res.list[i].posy01);
                  let intX_02 = parseInt(res.list[i].posx02);
                  let intY_02 = parseInt(res.list[i].posy02) ;
                  let intX_03 = parseInt(res.list[i].posx03);
                  let intY_03 = parseInt(res.list[i].posy03) ;
                  let intX_04 = parseInt(res.list[i].posx04);
                  let intY_04 = parseInt(res.list[i].posy04) ;
                  let intX_05 = parseInt(res.list[i].posx05);
                  let intY_05 = parseInt(res.list[i].posy05) ;
                  let intX_06 = parseInt(res.list[i].posx06);
                  let intY_06 = parseInt(res.list[i].posy06) ;

                  this.addYardItem(strACODE, strBATCH, intCOLOR_R, intCOLOR_G, intCOLOR_B, intGON, strDESCRIPT, strPOS_DIV, strSTATUS, intTEXT_COLOR_R, intTEXT_COLOR_G, intTEXT_COLOR_B, intLINE_COLOR_R, intLINE_COLOR_G, intLINE_COLOR_B,
                      intX_01, intY_01, intX_02, intY_02, intX_03, intY_03, intX_04, intY_04, intX_05, intY_05, intX_06, intY_06);

                  if (strACODE === "DK01" || strACODE === "DK02") {
                      this.addDockItem(strACODE, intX_01, intX_03, intY_01, intY_03, intX_01, intY_01, intX_02, intY_02, intX_03, intY_03, intX_04, intY_04, intX_05, intY_05, intX_06, intY_06);
                  }
              }

              // console.log("1. this.addYardItem...", this.YardObjList);
              // console.log("11. this.this...", this.DockObjList);
          }
      } catch (error) {
          console.error("Lỗi khi tải dữ liệu:", error);
      }
    },
    //OK
    async LoadBlkList() {
      try {
        let params = { strStartDate: this.selectedDate };
        let res = await getAddObjBlk(params);
        
        if (res.list.length > 0) {
          this.Blk_Cnt = res.list.length;
          this.resetBlkList();
          
          for (let item of res.list) {
            let blkInfo = {
              loc: item.loc,
              shipno: item.shipno,
              block: item.block,
              blockdesc: item.blockdesc,
              peblk: item.peblk,
              tover: item.tover,
              pe: item.pe,
              disorder: parseInt(item.disorder),
              addloc: item.addloc,
              erectblk: item.erectblk,
              status: item.status,
              sizel: Math.max(1, parseInt(item.sizel)),
              sizeb: Math.max(1, parseInt(item.sizeb)),
              sized: Math.max(1, parseInt(item.sized)),
              weight: parseInt(item.weight),
              posx: parseInt(item.posx),
              posy: parseInt(item.posy),
              rotation: item.rotation,
              juya: item.juya,
              disloc: item.disloc,
              l1: parseInt(item.l1),
              l2: parseInt(item.l2),
              tm: item.tm,
              afterpnt: item.afterpnt,
              edt: item.edt,
              arrange: item.arrange,
              prestatus: item.prestatus,
              actercdt: item.actercdt,
              vsblstatus: item.vsblstatus,
            };

            // Xác định màu sắc dựa trên trạng thái
            let colorMap = {
              "1": [245, 245, 245], "2": [245, 245, 245], "4": [245, 245, 245],//220, 220, 220
              "3": [245, 240, 197], "5": [245, 240, 197], "6": [245, 240, 197],
              "7": [226, 166, 180], "8": [226, 166, 180],
              "9": [190, 163, 201], "A": [190, 163, 201],
              "B": [68, 140, 203], "C": [68, 140, 203],//"B": [153, 155, 230], "C": [68, 140, 203]
              "D": [203, 221, 97], "E": [203, 221, 97],
            };

            if (colorMap[item.status]) {
              [blkInfo.colorr, blkInfo.colorg, blkInfo.colorb] = colorMap[item.status];
            } else {
              [blkInfo.colorr, blkInfo.colorg, blkInfo.colorb] = [136, 136, 136];
            }

            if (item.shipno === "000000") {
              [blkInfo.colorr, blkInfo.colorg, blkInfo.colorb] = [252, 211, 116];
            }

            blkInfo.vfill = 0;

            // Xác định tọa độ khối dựa trên rotation
            let { posx, posy, sizel, sizeb, sized, rotation } = blkInfo;
            let sizeMap = {
              "1": [sizel, sizeb], "2": [sizeb, sizel], "3": [sizel, sized],
              "4": [sized, sizel], "5": [sizeb, sized], "6": [sized, sizeb]
            };
            
            if (sizeMap[rotation]) {
              let [dx, dy] = sizeMap[rotation];
              blkInfo.blkx01 = posx;
              blkInfo.blky01 = posy;
              blkInfo.blkx02 = posx + dx * 2;
              blkInfo.blky02 = posy;
              blkInfo.blkx03 = posx + dx * 2;
              blkInfo.blky03 = posy + dy * 2;
              blkInfo.blkx04 = posx;
              blkInfo.blky04 = posy + dy * 2;
            }

            this.addBlkItem(
              blkInfo.loc, blkInfo.shipno, blkInfo.block,  blkInfo.blockdesc, blkInfo.peblk, blkInfo.tover,
              blkInfo.pe, blkInfo.disorder, blkInfo.addloc, blkInfo.erectblk, blkInfo.status,
              blkInfo.sizel, blkInfo.sizeb, blkInfo.sized, blkInfo.weight, blkInfo.posx, blkInfo.posy,
              blkInfo.rotation, blkInfo.juya, blkInfo.disloc, blkInfo.l1, blkInfo.l2, blkInfo.tm,
              blkInfo.afterpnt, blkInfo.edt, blkInfo.arrange, blkInfo.prestatus, blkInfo.actercdt,
              blkInfo.vfill, blkInfo.colorr, blkInfo.colorg, blkInfo.colorb, blkInfo.vsblstatus,
              blkInfo.blkx01, blkInfo.blky01, blkInfo.blkx02, blkInfo.blky02, blkInfo.blkx03, blkInfo.blky03,
              blkInfo.blkx04, blkInfo.blky04
            );
          }// end for loop
          // console.log("3. this.BlkObjList...", this.BlkObjList);
          // if(this.Blk_Cnt > 0){
          //   this.drawBlk();
          // }
        }
      } catch (error) {
        console.error("Error in LoadBlkList:", error);
      }
    },
    //OK
    drawText(descript, pos_x, pos_y, mfntstyle, fntcolor, mTextAlign){            
      pos_x = parseInt(pos_x) + 1.0;
      pos_y = parseInt(pos_y) + 4.0;
				
      this.context.save();
      this.context.fillStyle = fntcolor;
                
      switch(mfntstyle){
        case "m_fntdft" :
            this.context.font = "bold 400 11px Arial, sans-serif"; 
            break;         
        case "m_fntDateDesc" :  
            this.context.font = "normal 400 10px Times New Roman, sans-serif"; 
            break; 
        case "m_fntshipdesc" :  
            this.context.font = "normal 400 8px Arial, sans-serif";
            break;
        case "m_fntweather2" :
            this.context.font = "normal 400 12px SimSun, sans-serif"; 
            break; 
        case "m_fntHVS" :
            this.context.font = "bold 700 20px Arial, sans-serif"; 
            break;
        case "m_fntDisTribute" :
            this.context.font = "normal 400 14px SimSun, sans-serif"; 
            break; 
        case "m_fntShipCnt" :
            this.context.font = "normal 400 10px SimSun, sans-serif"; 
            break; 
        case "m_fntmainjob" :
            this.context.font = "normal 400 15px Cambria, sans-serif"; 
            break; 
        case "m_fntmainjob22" :
            this.context.font = "normal bold 15px Cambria, sans-serif"; 
            break; 
        case "m_fntRemark" :
            this.context.font = "normal 400 12px Arial, sans-serif"; 
            break; 
          case "m_fntRemark22" :
            this.context.font = "normal bold 12px Arial, sans-serif"; 
            break; 
        case "m_fntQuay" :
            this.context.font = "normal 400 13px Arial, sans-serif"; 
            break; 
        case "m_fntQuayDesc" :
            this.context.font = "normal 400 8px Arial, sans-serif"; 
            break; 
        case "m_fntQuayDesc22" :
            this.context.font = "normal 400 9px Arial, sans-serif"; 
            break; 
        case "m_fnt_VRemark" :
            this.context.font = "normal 400 11px Vni-Times, sans-serif"; 
            break;
        case "m_fntFlooding" :
            this.context.font = "bold 400 16px SimSun, sans-serif"; 
            break;
        case "m_fntMoving" :
            this.context.font = "bold 400 13px Arial, sans-serif"; 
            break;
        case "m_logFont" :
            this.context.font = "normal 400 12px Calibri, SimSun";   
            break;
        case "m_fntSCH" :
            this.context.font = "normal 400 13px Calibri, SimSun"; 
            break; 
        case "m_fntName" :
            this.context.font = "bold 800 500px Bauhaus 93, sans-serif"; 
            break; 
        case "m_fntName2" :
            this.context.font = "bold 800 300px Bauhaus 93, sans-serif"; 
            break; 
        case "m_fntHead" :
            this.context.font = "bold 800 38px Bauhaus 93, sans-serif"; 
            break;  
        default :
            this.context.font = "normal 400 10px Arial, sans-serif";
            break; 
      } ;
                
      switch(mTextAlign){
        case "0" :
          this.context.textAlign = 'left';	
          break;
        case "1" :
          this.context.textAlign = 'center';
          break ;
        case "2" :
          this.context.textAlign = 'right';
          break ;
        
        default :
          this.context.textAlign = 'left';	
          break;
      }  ; 	
                
      if(mTextAlign == "0") pos_x = pos_x + 2;							    
      this.context.textBaseline = 'top';
      this.context.fillText(descript, pos_x, pos_y);	
      this.context.restore();
							
    },//drawText Ending
	  //OK
    drawRotateText(descript, pos_x, pos_y, mfntstyle, fntcolor, inrot){
            	
      //(rotation radius: inrot = 2:90, inrot = 4: 45)            	
      pos_x = parseInt(pos_x) ;
     	pos_y = parseInt(pos_y) ;
				
      this.context.save();
      this.context.translate(pos_x, pos_y);
      this.context.rotate(- (parseInt(inrot) * Math.PI) / 180);
      this.context.textAlign = 'center' ;
      this.context.fillStyle = fntcolor;
				
      switch(mfntstyle){
        case "m_fntdft" :
            this.context.font = "bold 400 11px Arial, sans-serif"; 
            break;         
        case "m_fntweather" :  
            this.context.font = "normal 400 10px Times New Roman, sans-serif"; 
            break; 
        case "m_fntshipdesc" :  
            this.context.font = "normal 400 8px Arial, sans-serif";
            break;
        case "m_fntweather2" :
            this.context.font = "normal 400 12px SimSun, sans-serif"; 
            break; 
        case "m_fntHVS" :
            this.context.font = "bold 700 20px Arial, sans-serif"; 
            break;
        case "m_fntDisTribute" :
            this.context.font = "normal 400 14px SimSun, sans-serif"; 
            break; 
        case "m_fntShipCnt" :
            this.context.font = "normal 400 10px SimSun, sans-serif"; 
            break; 
        case "m_fntmainjob" :
            this.context.font = "normal 400 15px Cambria, sans-serif"; 
            break; 
        case "m_fntRemark" :
            this.context.font = "normal 400 12px Arial, sans-serif"; 
            break; 
        case "m_fntQuay" :
            this.context.font = "normal 400 13px Arial, sans-serif"; 
            break; 
        case "m_fntQuayDesc" :
            this.context.font = "normal 400 7px Arial, sans-serif"; 
            break; 
        case "m_fnt_VRemark" :
            this.context.font = "normal 400 11px Vni-Times, sans-serif"; 
            break;
        case "m_fntFlooding" :
            this.context.font = "bold 400 16px SimSun, sans-serif"; 
            break;
        case "m_fntMoving" :
            this.context.font = "bold 400 13px Arial, sans-serif"; 
            break;
        case "m_logFont" :
            this.context.font = "normal 400 12px Calibri, SimSun";   
            break;
        case "m_fntSCH" :
            this.context.font = "normal 400 13px Calibri, SimSun"; 
            break; 
        case "m_fntName" :
            this.context.font = "bold 800 500px Bauhaus 93, sans-serif"; 
            break; 
        case "m_fntName2" :
            this.context.font = "bold 800 300px Bauhaus 93, sans-serif"; 
            break; 
        case "m_fntHead" :
            this.context.font = "bold 800 38px Bauhaus 93, sans-serif"; 
            break;  
        default :
            this.context.font = "normal 400 10px Arial, sans-serif";
            break; 
      } ;
                		    
      // this.context.textBaseline = 'top';
      //fillText('center', 0, lineHeight / 2)
      // var lineHeight = parseInt(this.context.font.match(/\d+/), 15);
      this.context.fillText(descript, 0, Math.ceil(15/2));					
      this.context.restore();	
							
    },//drawRotateText Ending
    
    //For Dock
    //Load database
    addDockItem(
      strACODE, intLEFT, intRIGHT, intTOP, intBOTTOM, intX_01, intY_01, intX_02, intY_02,
      intX_03, intY_03, intX_04, intY_04, intX_05, intY_05, intX_06, intY_06
    ) 
    {
      const dkItem = {
        acode: strACODE,
        dkleft: intLEFT,
        dkright: intRIGHT,
        dktop: intTOP,
        dkbottom: intBOTTOM,
        posx01: intX_01,
        posy01: intY_01,
        posx02: intX_02,
        posy02: intY_02,
        posx03: intX_03,
        posy03: intY_03,
        posx04: intX_04,
        posy04: intY_04,
        posx05: intX_05,
        posy05: intY_05,
        posx06: intX_06,
        posy06: intY_06
      };
      this.DockObjList.push(dkItem);
    },
    getDKItem(strACODE, strItem) {
      let rtnValue = 0;
      const item = this.DockObjList.find(dk => dk.acode === strACODE);
      if (item) {
        const fields = {
          "DK_LEFT": item.dkleft,
          "DK_RIGHT": item.dkright,
          "DK_TOP": item.dktop,
          "DK_BOTTOM": item.dkbottom,
          "X_01": item.posx01,
          "Y_01": item.posy01,
          "X_02": item.posx02,
          "Y_02": item.posy02,
          "X_03": item.posx03,
          "Y_03": item.posy03,
          "X_04": item.posx04,
          "Y_04": item.posy04,
          "X_05": item.posx05,
          "Y_05": item.posy05,
          "X_06": item.posx06,
          "Y_06": item.posy06
        };
        rtnValue = fields[strItem] || 0;
      }
      return rtnValue;
    },
    resetDockList() {
      this.DockObjList = [];
    },
    //For Yard
    addYardItem(
      strACODE, strBATCH, intCOLOR_R, intCOLOR_G, intCOLOR_B, intGON, strDESCRIPT, strPOS_DIV,
      strSTATUS, intTEXT_COLOR_R, intTEXT_COLOR_G, intTEXT_COLOR_B, intLINE_COLOR_R, 
      intLINE_COLOR_G, intLINE_COLOR_B, intX_01, intY_01, intX_02, intY_02, intX_03, intY_03, 
      intX_04, intY_04, intX_05, intY_05, intX_06, intY_06
    ) {
      const yardItem = {
        acode: strACODE,
        batch: strBATCH,
        colorr: intCOLOR_R,
        colorg: intCOLOR_G,
        colorb: intCOLOR_B,
        gon: intGON,
        descript: strDESCRIPT,
        posdiv: strPOS_DIV,
        status: strSTATUS,
        textcolorr: intTEXT_COLOR_R,
        textcolorg: intTEXT_COLOR_G,
        textcolorb: intTEXT_COLOR_B,
        linecolorr: intLINE_COLOR_R,
        linecolorg: intLINE_COLOR_G,
        linecolorb: intLINE_COLOR_B,
        posx01: intX_01,
        posy01: intY_01,
        posx02: intX_02,
        posy02: intY_02,
        posx03: intX_03,
        posy03: intY_03,
        posx04: intX_04,
        posy04: intY_04,
        posx05: intX_05,
        posy05: intY_05,
        posx06: intX_06,
        posy06: intY_06
      };
      this.YardObjList.push(yardItem);
    },
    removeYardItem(ACODE) {
      this.YardObjList = this.YardObjList.filter(item => item.acode !== ACODE);
    },
    resetYardList() {
      this.YardObjList = [];
    },
    //For Block
    addBlkItem(
      strLOC, strSHIP_NO, strBLOCK, strBLOCK_DESC, strPE_BLK, strTOVER, strPE, intDIS_ORDER, strADD_LOC, strERECT_BLK, strSTATUS, 
      intSIZE_L, intSIZE_B, intSIZE_D, intWEIGHT, intPOSX, intPOSY, strROTATION, strJUYA, strDIS_LOC, intL1, intL2, intTM,
      strAFTER_PNT, strEDT, strARRANGE, strPRE_STATUS, strACT_ERCDT, intV_FILL, intCOLOR_R, intCOLOR_G, intCOLOR_B, strVSBL_STATUS, 
      intX_01, intY_01, intX_02, intY_02, intX_03, intY_03, intX_04, intY_04
    ) {
      const blkItem = {
        loc: strLOC,
        shipno: strSHIP_NO,
        block: strBLOCK,
        blockdesc: strBLOCK_DESC,
        peblk: strPE_BLK,
        tover: strTOVER,
        pe: strPE,
        disorder: intDIS_ORDER,
        addloc: strADD_LOC,
        erectblk: strERECT_BLK,
        status: strSTATUS,
        sizel: intSIZE_L,
        sizeb: intSIZE_B,
        sized: intSIZE_D,
        weight: intWEIGHT,
        posx: intPOSX,
        posy: intPOSY,
        rotation: strROTATION,
        juya: strJUYA,
        disloc: strDIS_LOC,
        l1: intL1,
        l2: intL2,
        tm: intTM,
        after_pnt: strAFTER_PNT,
        edt: strEDT,
        arrange: strARRANGE,
        prestatus: strPRE_STATUS,
        actercdt: strACT_ERCDT,
        vfill: intV_FILL,
        colorr: intCOLOR_R,
        colorg: intCOLOR_G,
        colorb: intCOLOR_B,
        vsblstatus: strVSBL_STATUS,
        blkx01: intX_01,
        blky01: intY_01,
        blkx02: intX_02,
        blky02: intY_02,
        blkx03: intX_03,
        blky03: intY_03,
        blkx04: intX_04,
        blky04: intY_04
      };
      this.BlkObjList.push(blkItem);
    },
    removeBlkItem(strSHIP_NO, strBLOCK) {
      this.BlkObjList = this.BlkObjList.filter(item => !(item.shipno === strSHIP_NO && item.block === strBLOCK));
    },
    resetBlkList() {
      this.BlkObjList = [];
    },

    CalcHorInDock(rect_left, pos)
    {
      var value;
      value = (rect_left + Math.ceil(pos) * 2) * this.zoom / 100; 
      return value;
    },

    CalcVerInDock(rect_top, pos)
    {
      var value;
      value = (rect_top + Math.ceil(pos) * 2) * this.zoom / 100; 
      return value;
    },
    handleMouseMove(event) {
      const canvas = this.$refs.ani;
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      let found = false;
      this.objects.forEach(obj => {
        if ( 
          mouseX >= obj.x &&
          mouseX <= obj.x + obj.width &&
          mouseY >= obj.y &&
          mouseY <= obj.y + obj.height
        ) {
          this.tooltip = {
            show: true,
            x: event.clientX + 10, // Tooltip xuất hiện cạnh con trỏ
            y: event.clientY + 10,
            data: obj
          };
          found = true;
        }
      });

      if (!found) this.hideTooltip();
    },
    hideTooltip() {
      this.tooltip.show = false;
    }
  }
};
</script>
<style >
  /* Canh giữa cho thanh Bar */
 .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7); /* Làm mờ nền */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  /* Canh hiển thị chữ Loading... */
  .loading-text {
    font-size: 18px;
    font-weight: bold;
    color: #1976D2; /* Màu xanh của Vuetify */
    margin-top: 10px;
  }

  .tooltip-box {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    border-radius: 5px;
    font-size: 12px;
    pointer-events: auto; /* auto: Bật nhận sự kiện -none: Chặn*/
    cursor: pointer; /* Hiển thị bàn tay khi hover */
  }
</style>